var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPadaria(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_2",
    "data-name": "Camada 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640.51 587.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2, .cls-3, .cls-4 {\n        fill: #fff;\n      }\n\n      .cls-5, .cls-6, .cls-7 {\n        fill: #472917;\n      }\n\n      .cls-6, .cls-2, .cls-8, .cls-9, .cls-7, .cls-10, .cls-11, .cls-12, .cls-13, .cls-14, .cls-15, .cls-16, .cls-4, .cls-17 {\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n\n      .cls-6, .cls-2, .cls-9, .cls-3, .cls-7, .cls-10, .cls-12, .cls-13, .cls-14, .cls-18, .cls-16, .cls-4, .cls-17 {\n        stroke: #472917;\n      }\n\n      .cls-2, .cls-7, .cls-14, .cls-18, .cls-15 {\n        stroke-width: .75px;\n      }\n\n      .cls-8, .cls-10, .cls-11, .cls-14, .cls-18, .cls-15 {\n        fill: none;\n      }\n\n      .cls-8, .cls-15 {\n        stroke: #fff;\n      }\n\n      .cls-9 {\n        fill: #f06b36;\n      }\n\n      .cls-3, .cls-18 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-11 {\n        stroke: #f17746;\n      }\n\n      .cls-12 {\n        fill: #fac9b5;\n      }\n\n      .cls-13 {\n        fill: #f6a280;\n      }\n\n      .cls-16 {\n        fill: #c9582d;\n      }\n\n      .cls-17 {\n        fill: #a34724;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Lamps--inject-273"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 45.31,
    y: 40.77,
    width: 32.76,
    height: 68.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 45.31,
    y: 40.77,
    width: 32.76,
    height: 28.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 60.36,
    y: 0.5,
    width: 2.65,
    height: 43.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 392.9,
    y: 40.77,
    width: 32.76,
    height: 68.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 392.9,
    y: 40.77,
    width: 32.76,
    height: 28.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 407.94,
    y: 0.5,
    width: 2.65,
    height: 43.37
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Blackboard--inject-273"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 446.65,
    y: 111.58,
    width: 104.44,
    height: 192.95
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 467.52,
    y1: 125.85,
    x2: 532.89,
    y2: 125.85
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 456.96,
    y1: 145.55,
    x2: 493.53,
    y2: 145.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 456.96,
    y1: 161.72,
    x2: 493.53,
    y2: 161.72
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 456.96,
    y1: 177.89,
    x2: 493.53,
    y2: 177.89
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 456.96,
    y1: 194.06,
    x2: 493.53,
    y2: 194.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 456.96,
    y1: 210.23,
    x2: 493.53,
    y2: 210.23
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 456.96,
    y1: 226.4,
    x2: 493.53,
    y2: 226.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 456.96,
    y1: 242.57,
    x2: 493.53,
    y2: 242.57
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 456.96,
    y1: 258.74,
    x2: 493.53,
    y2: 258.74
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 456.96,
    y1: 274.9,
    x2: 493.53,
    y2: 274.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 501.96,
    y1: 145.55,
    x2: 538.51,
    y2: 145.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 501.96,
    y1: 161.72,
    x2: 538.51,
    y2: 161.72
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 501.96,
    y1: 177.89,
    x2: 538.51,
    y2: 177.89
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 501.96,
    y1: 194.06,
    x2: 538.51,
    y2: 194.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 501.96,
    y1: 210.23,
    x2: 538.51,
    y2: 210.23
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 501.96,
    y1: 226.4,
    x2: 538.51,
    y2: 226.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 501.96,
    y1: 242.57,
    x2: 538.51,
    y2: 242.57
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 501.96,
    y1: 258.74,
    x2: 538.51,
    y2: 258.74
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 501.96,
    y1: 274.9,
    x2: 538.51,
    y2: 274.9
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-273"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 0.5,
    y1: 586.24,
    x2: 636.57,
    y2: 586.24
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-273"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m535.89,407.48s-2.97,8.18-9.3,9.3c-6.33,1.12-17.48-11.15-10.42-17.48,7.06-6.33,16.75,3.72,19.72,8.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m545.56,367.32s-9.3,22.68-5.53,33.85c3.77,11.17,26.78,19.35,33.47,4.84,6.69-14.51-8.18-34.97-13.82-39.43-5.64-4.46-12.27-2.99-14.12.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m599.86,376.98s-15.99,14.51-17.86,29.02c-1.87,14.51,8.93,19.71,20.1,17.86,11.17-1.85,16.74-30.13,13.38-43.15-3.36-13.02-15.62-3.73-15.62-3.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m602.84,457.33s-17.86.75-18.59,9.3,7.81,10.41,16.36,2.97c8.56-7.44,9.67-11.9,2.23-12.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m584.54,468.66s14.07-6.44,20.41-7.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m606.82,513.25s-13.12-12.13-19.71-6.63-1.88,12.88,9.44,13.71,15.27-1.48,10.27-7.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m585.88,508.32s14.48,5.45,19.75,9.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m537.64,509.74s18.08-16.74,27.16-9.15c9.08,7.59,2.6,17.76-12.99,18.89-15.59,1.13-21.04-2.09-14.17-9.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m566.51,502.86s-19.97,7.5-27.23,12.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m558.58,475.19s-1.87,8.93-8.56,12.27c-6.69,3.34-18.6-3.72-12.29-14.51,6.32-10.79,17.48-2.23,20.84,2.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m542.95,447.28s-3.34-7.44-16.36-2.6c-13.02,4.84-18.23,12.27-10.05,14.87,8.18,2.6,26.41-12.27,26.41-12.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m540.46,446.91s-13.82,1.48-21.24,7.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m580.16,358.02s2.23,5.21,6.69,4.15,5.53-7.81,12.65-5.96c7.12,1.85,13.02,10.05,13.02,6.33s-8.93-13.39-18.96-13.39-13.02,4.04-13.39,8.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m542.95,447.28s16.02-3.07,22.69,14.72c.66,1.78,1.21,3.59,1.67,5.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m609.8,430.05s3.34-7.44,16.36-2.6,18.23,12.27,10.05,14.88c-8.18,2.61-26.41-12.29-26.41-12.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m612.77,430.55s13.42-.75,19.75,7.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m609.8,430.05c-3.76-.51-7.58.01-11.06,1.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m551.49,416.71c-7.85-8.02-15.6-9.23-15.6-9.23,0,0-11.46-3.03-15.94,1.08"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 553.08,
    y1: 375.51,
    x2: 552.39,
    y2: 372.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m571.2,539.95s1.67-64.06,0-83.52c-1.67-19.46-9.45-42.24-9.45-42.24l-7.97-35.39"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 604.26,
    y1: 389.26,
    x2: 605.7,
    y2: 386.18
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m575.08,539.88s.57-58.43,2.76-75.1c2.2-16.67,11.13-42.84,11.13-42.84l13.64-29.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m584.54,468.66s-3.88,33.5-6.11,71.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m565.64,539.88s1.11-53.43-1.12-60.66-5.94-4.04-5.94-4.04c0,0-10.3,1.2-14.03,7.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m568.19,471.61c2.92,16.29.23,68.33.23,68.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m595.57,433.31c-3.95,2.84-6.9,6.85-8.46,11.46-6.66,17.79-5.9,95.2-5.9,95.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m553.43,418.83c4.17,5.04,7.37,10.82,9.44,17.03,8.89,25.57,12.22,91.78,10.56,104.01"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m576.01,442.76c-.54,32.26-.93,97.12-.93,97.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m576.08,438.74c.37-21.34.8-42.22,1.23-53.44,1.12-28.91,2.85-27.28,2.85-27.28,0,0,2.06-6.5,13.61-5.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m561.84,463.11s-9.3-8.29-5.53-12.44c3.77-4.15,26.77-7.06,33.47-1.77,6.7,5.29-8.18,12.78-13.82,14.42s-12.26,1.16-14.12-.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m570.44,456.32c-.14.82-.21,1.65-.21,2.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m573.63,446.63c-.95,1.99-1.75,4.05-2.39,6.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m561.84,517.4s-9.3-8.29-5.53-12.37c3.77-4.08,26.77-7.06,33.47-1.77,6.7,5.29-8.18,12.78-13.82,14.42-5.64,1.63-12.26,1.02-14.12-.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m573.63,500.81s-3.4,6.8-3.4,12.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m568.77,494.4s-6.32-5.63-3.79-8.4c2.53-2.78,18.19-4.8,22.74-1.19,4.55,3.61-5.53,8.67-9.34,9.77s-8.33.7-9.61-.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m576.77,483.22c-1.29,2.59-2.07,5.41-2.31,8.29"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 560.03,
    y: 530.66,
    width: 25.17,
    height: 55.82
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shelves--inject-273"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m60,209.29c1.81-.05,3.23-1.56,3.18-3.37,0,0,0,0,0,0,.25-2.16,1.41-4.12,3.19-5.38l-5.97-8.29-.4,17.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m60,275.66c1.81-.05,3.23-1.56,3.18-3.37,0,0,0,0,0,0,.25-2.16,1.41-4.12,3.19-5.38l-5.97-8.29-.4,17.04Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 55,
    y: 185.6,
    width: 5.11,
    height: 395.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 372.79,
    y: 185.6,
    width: 5.11,
    height: 395.34
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "381.32 258.01 412.68 301.92 352.17 301.92 320.81 258.01 381.32 258.01"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 320.81,
    y: 251.48,
    width: 60.51,
    height: 6.54
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "412.68 301.92 381.32 258.01 381.32 251.48 412.68 295.38 412.68 301.92"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 376.62,
    cy: 259.8,
    rx: 9.49,
    ry: 6.47
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m368.38,260.77s-1.09.21,1.64-1.98c2.74-2.18,4.26-1.52,5.89-2.5,1.32-.92,2.87-1.45,4.48-1.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m370.23,263.38c.83-.89,1.89-1.53,3.07-1.85,1.97-.62,3.74-1.75,5.13-3.28,1.5-1.31,3.47-1.94,5.45-1.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m374.71,265.35s2.63-2.18,4.15-3.16c1.16-.74,2.46-1.22,3.83-1.38.94-.3,1.8-.83,2.5-1.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m379.95,258.95c0,.75-1.49,1.38-3.33,1.38s-3.32-.61-3.32-1.38,1.48-1.38,3.32-1.38,3.33.66,3.33,1.38Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 384.15,
    cy: 271.15,
    rx: 9.49,
    ry: 6.47
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m375.91,272.12s-1.09.22,1.63-1.96c2.72-2.18,4.26-1.53,5.9-2.52,1.33-.91,2.87-1.44,4.48-1.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m377.76,274.73c.83-.89,1.89-1.53,3.05-1.85,1.97-.62,3.75-1.75,5.14-3.28,1.5-1.3,3.47-1.93,5.45-1.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m382.24,276.69s2.63-2.17,4.15-3.16c1.15-.74,2.46-1.21,3.81-1.38.95-.3,1.81-.83,2.52-1.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m387.48,270.32c0,.75-1.49,1.38-3.33,1.38s-3.33-.61-3.33-1.38,1.49-1.38,3.33-1.38,3.33.64,3.33,1.38Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 391.67,
    cy: 282.51,
    rx: 9.49,
    ry: 6.47
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m383.45,283.47s-1.09.22,1.63-1.96c2.72-2.18,4.26-1.53,5.9-2.52,1.32-.91,2.86-1.44,4.46-1.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m385.3,286.09c.83-.89,1.88-1.54,3.05-1.87,1.97-.61,3.74-1.74,5.13-3.28,1.52-1.32,3.52-1.95,5.53-1.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m389.78,288.05s2.61-2.18,4.15-3.16c1.15-.74,2.46-1.21,3.81-1.38.95-.3,1.81-.83,2.52-1.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m395.01,281.68c0,.75-1.49,1.38-3.33,1.38s-3.33-.59-3.33-1.38,1.49-1.38,3.33-1.38,3.33.64,3.33,1.38Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 357.46,
    cy: 259.8,
    rx: 9.49,
    ry: 6.47
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m349.23,260.77s-1.09.21,1.64-1.98c2.74-2.18,4.24-1.52,5.89-2.5,1.32-.92,2.87-1.45,4.48-1.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m351.08,263.38c.83-.89,1.89-1.53,3.05-1.85,1.97-.62,3.75-1.75,5.14-3.28,1.5-1.31,3.47-1.94,5.45-1.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m355.56,265.35s2.63-2.18,4.15-3.16c1.16-.74,2.46-1.22,3.83-1.38.94-.3,1.8-.83,2.5-1.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m360.79,258.95c0,.75-1.49,1.38-3.33,1.38s-3.33-.61-3.33-1.38,1.49-1.38,3.33-1.38,3.33.66,3.33,1.38Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 364.99,
    cy: 271.15,
    rx: 9.49,
    ry: 6.47
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m356.76,272.12s-1.09.22,1.63-1.96c2.72-2.18,4.26-1.53,5.9-2.52,1.33-.91,2.87-1.44,4.48-1.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m358.61,274.73c.83-.89,1.89-1.53,3.05-1.85,1.97-.62,3.74-1.75,5.13-3.28,1.52-1.32,3.52-1.95,5.53-1.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m363.05,276.69s2.61-2.17,4.15-3.16c1.15-.74,2.46-1.21,3.81-1.38.95-.3,1.81-.83,2.52-1.53"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-13",
    cx: 364.99,
    cy: 270.32,
    rx: 3.33,
    ry: 1.35
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 372.51,
    cy: 282.51,
    rx: 9.49,
    ry: 6.47
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m364.29,283.47s-1.09.22,1.63-1.96c2.72-2.18,4.26-1.53,5.9-2.52,1.32-.91,2.86-1.44,4.46-1.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m366.14,286.09c.83-.89,1.88-1.54,3.05-1.87,1.97-.61,3.74-1.74,5.13-3.28,1.51-1.3,3.48-1.93,5.46-1.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m370.62,288.05s2.61-2.18,4.15-3.16c1.15-.74,2.46-1.21,3.81-1.38.95-.3,1.81-.83,2.52-1.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m375.86,281.68c0,.75-1.49,1.38-3.33,1.38s-3.33-.59-3.33-1.38,1.49-1.38,3.33-1.38,3.33.64,3.33,1.38Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-16",
    cx: 338.31,
    cy: 259.8,
    rx: 9.49,
    ry: 6.47
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m330.07,260.77s-1.09.21,1.63-1.98c2.72-2.18,4.26-1.52,5.9-2.5,1.32-.92,2.87-1.45,4.48-1.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m331.92,263.38c.83-.89,1.89-1.53,3.05-1.85,1.97-.62,3.74-1.75,5.13-3.28,1.52-1.32,3.52-1.95,5.53-1.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m336.4,265.35s2.61-2.18,4.15-3.16c1.15-.74,2.46-1.21,3.81-1.38.95-.3,1.81-.83,2.52-1.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m341.64,258.95c0,.75-1.49,1.38-3.33,1.38s-3.33-.61-3.33-1.38,1.49-1.38,3.33-1.38,3.33.66,3.33,1.38Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-16",
    cx: 345.83,
    cy: 271.15,
    rx: 9.49,
    ry: 6.47
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m337.6,272.12s-1.09.22,1.63-1.96c2.72-2.18,4.26-1.53,5.9-2.52,1.32-.91,2.86-1.44,4.46-1.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m339.45,274.73c.83-.89,1.89-1.53,3.05-1.85,1.97-.62,3.74-1.75,5.13-3.28,1.51-1.3,3.48-1.93,5.46-1.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m343.93,276.69s2.61-2.17,4.15-3.16c1.15-.74,2.46-1.21,3.81-1.38.95-.3,1.81-.83,2.52-1.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m349.23,270.32c0,.75-1.49,1.38-3.33,1.38s-3.33-.61-3.33-1.38,1.49-1.38,3.33-1.38,3.33.64,3.33,1.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m362.87,282.51c0,3.57-4.26,6.47-9.51,6.47s-9.49-2.9-9.49-6.47,4.26-6.47,9.49-6.47,9.51,2.89,9.51,6.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m345.08,283.47s-1.09.22,1.63-1.96c2.72-2.18,4.26-1.53,5.9-2.52,1.32-.91,2.86-1.44,4.46-1.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m346.99,286.09c.83-.89,1.88-1.54,3.05-1.87,1.97-.61,3.74-1.74,5.13-3.28,1.51-1.3,3.48-1.93,5.46-1.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m351.46,288.05s2.61-2.18,4.15-3.16c1.15-.74,2.46-1.21,3.81-1.38.95-.3,1.81-.83,2.52-1.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m356.7,281.68c0,.75-1.49,1.38-3.33,1.38s-3.33-.59-3.33-1.38,1.49-1.38,3.33-1.38,3.33.64,3.33,1.38Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 397.94,
    cy: 291.74,
    rx: 9.49,
    ry: 6.47
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m389.72,292.7s-1.09.22,1.63-1.96,4.26-1.52,5.9-2.5c1.32-.91,2.86-1.45,4.46-1.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m391.57,295.32c.83-.89,1.88-1.53,3.05-1.85,1.97-.62,3.74-1.75,5.13-3.28,1.5-1.3,3.48-1.93,5.46-1.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m396.05,297.29s2.61-2.18,4.15-3.16c1.15-.74,2.46-1.21,3.81-1.38.95-.29,1.82-.81,2.52-1.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m401.29,290.92c0,.75-1.49,1.38-3.33,1.38s-3.33-.61-3.33-1.38,1.49-1.38,3.33-1.38,3.33.64,3.33,1.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m388.28,291.74c0,3.58-4.24,6.47-9.49,6.47s-9.49-2.89-9.49-6.47,4.26-6.47,9.49-6.47,9.49,2.9,9.49,6.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m370.56,292.7s-1.09.22,1.63-1.96,4.26-1.52,5.89-2.5c1.32-.91,2.87-1.44,4.48-1.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m372.42,295.32c.83-.88,1.9-1.51,3.07-1.82,1.97-.62,3.74-1.75,5.13-3.28,1.5-1.3,3.48-1.93,5.46-1.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m376.87,297.29s2.61-2.18,4.15-3.16c1.15-.74,2.46-1.21,3.81-1.38.95-.29,1.82-.81,2.52-1.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m382.13,290.92c0,.75-1.49,1.38-3.33,1.38s-3.33-.61-3.33-1.38,1.49-1.38,3.33-1.38,3.33.64,3.33,1.38Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-16",
    cx: 359.63,
    cy: 291.74,
    rx: 9.49,
    ry: 6.47
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m351.41,292.7s-1.09.22,1.63-1.96,4.26-1.52,5.89-2.5c1.32-.91,2.87-1.44,4.48-1.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m353.26,295.32c.83-.89,1.88-1.53,3.05-1.85,1.97-.62,3.74-1.75,5.13-3.28,1.52-1.32,3.52-1.95,5.53-1.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m357.74,297.29s2.61-2.18,4.15-3.16c1.15-.74,2.46-1.21,3.81-1.38.95-.29,1.82-.81,2.52-1.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m363.05,290.92c0,.75-1.49,1.38-3.33,1.38s-3.33-.61-3.33-1.38,1.49-1.38,3.33-1.38,3.33.64,3.33,1.38Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "352.17 301.92 320.81 258.01 320.81 251.48 352.17 295.38 352.17 301.92"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 352.17,
    y: 295.38,
    width: 60.51,
    height: 6.54
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "316.1 258.01 347.46 301.92 286.95 301.92 255.59 258.01 316.1 258.01"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 255.59,
    y: 251.48,
    width: 60.51,
    height: 6.54
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "347.46 301.92 316.1 258.01 316.1 251.48 347.46 295.38 347.46 301.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "286.95 301.92 255.59 258.01 255.59 251.48 286.95 295.38 286.95 301.92"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 286.95,
    y: 295.38,
    width: 60.51,
    height: 6.54
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "250.89 258.01 282.25 301.92 221.74 301.92 190.38 258.01 250.89 258.01"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 190.38,
    y: 251.48,
    width: 60.51,
    height: 6.54
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "282.25 301.92 250.89 258.01 250.89 251.48 282.25 295.38 282.25 301.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "221.74 301.92 190.38 258.01 190.38 251.48 221.74 295.38 221.74 301.92"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 221.74,
    y: 295.38,
    width: 60.51,
    height: 6.54
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "185.67 258.01 217.03 301.92 156.52 301.92 125.16 258.01 185.67 258.01"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 125.16,
    y: 251.48,
    width: 60.51,
    height: 6.54
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "217.03 301.92 185.67 258.01 185.67 251.48 217.03 295.38 217.03 301.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "156.52 301.92 125.16 258.01 125.16 251.48 156.52 295.38 156.52 301.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m166.69,251.6c-.81,2.43-.57,5.09.65,7.34,2.43,4.66,7.63,14.1,12.96,20.21,7.33,8.38,18.58,20.4,22.76,16.47s-3.66-18.56-14.39-31.39c-9.38-11.21-19.13-20.62-21.99-12.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m171.16,249.27s-3.93,1.31-2.61,3.93,5.53,2.36,4.7,3.66-4.7.53-2.35,3.66c2.35,3.14,6.01.53,5.75,2.87-.26,2.35-3.4,3.4-.51,5.53,2.89,2.13,7.84-.53,8.1,2.09.26,2.61-4.15,3.14-.53,6.54,3.62,3.4,6.29.79,6.55,2.1.26,1.31-2.36,3.14,0,5.22,2.36,2.09,4.44.53,5.22,1.05s-1.05,1.82,1.05,3.4c2.1,1.58,3.66,2.09,4.45,1.05s2.09,0,2.09-2.63-2.61-5.75-4.15-7.31c-1.53-1.56-1.82-3.93-3.14-5.76-1.31-1.84-1.82-2.87-2.87-3.4s-1.84-2.61-1.84-2.61c-.06-1.77-.92-3.41-2.35-4.45-2.35-1.56-4.15-2.87-4.15-2.87l-1.56-2.87c-2.36-2.1-4.45-3.93-4.45-3.93l-.79-1.84-3.22-2.05-3.4-1.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m152.31,252.63c-.81,2.43-.57,5.09.65,7.34,2.43,4.67,7.63,14.11,12.98,20.22,7.31,8.29,18.56,20.4,22.75,16.47,4.19-3.93-3.66-18.58-14.39-31.39-9.38-11.22-19.17-20.63-21.99-12.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m156.77,250.37s-3.93,1.38-2.61,3.93c1.31,2.54,5.53,2.35,4.71,3.66s-4.71.53-2.36,3.66c2.35,3.14,6.01.53,5.76,2.87-.25,2.35-3.4,3.4-.53,5.53s7.84-.53,8.1,2.09c.26,2.61-4.15,3.14-.51,6.54s6.27.79,6.54,2.1-2.36,3.14,0,5.22c2.36,2.09,4.44.53,5.22,1.05s-1.05,1.82,1.05,3.4,3.66,2.09,4.45,1.04,2.09,0,2.09-2.61-2.61-5.75-4.15-7.33c-1.53-1.58-1.82-3.93-3.14-5.75s-1.82-2.87-2.87-3.4-1.84-2.61-1.84-2.61c-.06-1.77-.92-3.41-2.35-4.45-2.35-1.58-4.15-2.87-4.15-2.87l-1.56-2.87c-2.36-2.1-4.45-3.93-4.45-3.93l-.79-1.84-3.14-2.09-3.48-1.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m137.92,253.68c-.81,2.43-.57,5.09.65,7.34,2.43,4.67,7.63,14.11,12.98,20.21,7.33,8.38,18.56,20.41,22.75,16.49,4.19-3.93-3.66-18.58-14.39-31.39-9.38-11.22-19.17-20.63-21.99-12.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m142.38,251.42s-3.93,1.3-2.61,3.93,5.53,2.35,4.71,3.66-4.71.53-2.36,3.66c2.35,3.14,6.03.53,5.76,2.87-.26,2.35-3.4,3.4-.53,5.53s7.85-.53,8.11,2.1c.26,2.63-4.15,3.14-.53,6.54s6.27.79,6.54,2.09c.26,1.3-2.36,3.14,0,5.24,2.36,2.1,4.45.53,5.22,1.04s-1.04,1.84,1.05,3.4c2.09,1.56,3.66,2.1,4.45,1.05s2.09,0,2.09-2.61-2.61-5.75-4.15-7.33-1.82-3.93-3.14-5.75c-1.31-1.82-1.82-2.89-2.87-3.4s-1.82-2.63-1.82-2.63c-.06-1.76-.93-3.4-2.36-4.44-2.35-1.58-4.15-2.89-4.15-2.89l-1.56-2.87c-2.35-2.09-4.45-3.93-4.45-3.93l-.79-1.82-3.14-2.1-3.48-1.34Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 156.52,
    y: 295.38,
    width: 60.51,
    height: 6.54
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "120.46 258.01 151.82 301.92 91.32 301.92 59.96 258.01 120.46 258.01"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 59.96,
    y: 251.48,
    width: 60.51,
    height: 6.54
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "151.82 301.92 120.46 258.01 120.46 251.48 151.82 295.38 151.82 301.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "91.32 301.92 59.96 258.01 59.96 251.48 91.32 295.38 91.32 301.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m106.05,253.06c-.81,2.43-.57,5.09.65,7.34,2.43,4.66,7.63,14.1,12.98,20.21,7.33,8.38,18.56,20.4,22.75,16.47s-3.66-18.56-14.39-31.39c-9.38-11.21-19.17-20.57-21.99-12.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m110.51,250.78s-3.93,1.31-2.61,3.93,5.53,2.36,4.71,3.66c-.82,1.3-4.71.53-2.36,3.66,2.35,3.14,6.03.53,5.76,2.87-.26,2.35-3.4,3.4-.53,5.53,2.87,2.13,7.85-.53,8.11,2.09.26,2.61-4.15,3.14-.53,6.54,3.62,3.4,6.27.79,6.54,2.1s-2.36,3.14,0,5.22,4.45.53,5.22,1.05c.77.53-1.04,1.82,1.05,3.4,2.09,1.58,3.66,2.09,4.45,1.05s2.09,0,2.09-2.63-2.61-5.75-4.15-7.31c-1.53-1.56-1.82-3.93-3.14-5.76-1.31-1.84-1.82-2.87-2.87-3.4-1.05-.53-1.82-2.61-1.82-2.61-.06-1.77-.93-3.41-2.36-4.45-2.35-1.56-4.15-2.87-4.15-2.87l-1.56-2.87c-2.35-2.1-4.45-3.93-4.45-3.93l-.79-1.84-3.22-2.17-3.4-1.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m91.66,254.1c-.81,2.43-.57,5.09.65,7.34,2.43,4.67,7.63,14.11,12.98,20.22,7.33,8.29,18.56,20.4,22.75,16.47,4.19-3.93-3.66-18.58-14.39-31.39-9.38-11.22-19.17-20.63-21.99-12.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m96.13,251.83s-3.93,1.38-2.61,3.93,5.53,2.35,4.71,3.66c-.82,1.31-4.71.53-2.36,3.66,2.35,3.14,6.03.53,5.76,2.87s-3.4,3.4-.53,5.53,7.85-.53,8.11,2.09-4.15,3.14-.53,6.54c3.62,3.4,6.27.79,6.54,2.1.26,1.31-2.35,3.14,0,5.22,2.35,2.09,4.45.53,5.22,1.05s-1.04,1.82,1.05,3.4,3.66,2.09,4.45,1.04,2.09,0,2.09-2.61-2.61-5.75-4.15-7.33c-1.53-1.58-1.82-3.93-3.14-5.75-1.31-1.82-1.82-2.87-2.87-3.4s-1.82-2.61-1.82-2.61c-.06-1.77-.93-3.41-2.36-4.45-2.35-1.58-4.15-2.87-4.15-2.87l-1.58-2.87c-2.35-2.1-4.45-3.93-4.45-3.93l-.79-1.84-3.14-2.09-3.47-1.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m77.27,255.15c-.8,2.43-.56,5.09.66,7.34,2.42,4.67,7.62,14.11,12.96,20.21,7.33,8.38,18.58,20.41,22.75,16.49,4.17-3.93-3.66-18.58-14.39-31.39-9.37-11.22-19.16-20.63-21.99-12.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m81.74,252.88s-3.91,1.3-2.61,3.93c1.3,2.63,5.53,2.35,4.71,3.66-.82,1.31-4.71.53-2.35,3.66,2.36,3.14,6.01.51,5.75,2.87-.26,2.36-3.4,3.4-.53,5.53s7.85-.53,8.11,2.1c.26,2.63-4.15,3.14-.53,6.54s6.27.79,6.54,2.09-2.35,3.14,0,5.24c2.35,2.1,4.45.53,5.24,1.04s-1.05,1.84,1.04,3.4c2.09,1.56,3.66,2.1,4.45,1.05.79-1.05,2.09,0,2.09-2.61s-2.61-5.75-4.15-7.33-1.84-3.93-3.15-5.75-1.82-2.89-2.87-3.4-1.82-2.63-1.82-2.63c-.06-1.76-.93-3.4-2.36-4.44-2.35-1.58-4.15-2.89-4.15-2.89l-1.6-2.92c-2.35-2.09-4.45-3.93-4.45-3.93l-.77-1.82-3.15-2.1-3.43-1.3Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 91.32,
    y: 295.38,
    width: 60.51,
    height: 6.54
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "376.36 185.6 407.71 229.51 347.21 229.51 315.85 185.6 376.36 185.6"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 315.85,
    y: 179.08,
    width: 60.51,
    height: 6.54
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "407.71 229.51 376.36 185.6 376.36 179.08 407.71 222.97 407.71 229.51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m374.1,193.91h0c-2.54,1.31-5.54,1.37-8.13.17l-.41-.18c-.87-.41-1.46-1.24-1.56-2.2l-.84-8.68h13.25l-.86,8.75c-.08.92-.63,1.72-1.45,2.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m367.45,177.5c-2.24.14-4.36,1.09-5.94,2.68-2.21,2.54,2.11,6.11,5.89,6.69,3.77.58,9.2-.37,10.71-2.17,1.51-1.8,1.13-4.08-1.67-5.98-2.81-1.91-6.84-1.45-8.98-1.22Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 366.49,
    y1: 187.33,
    x2: 366.78,
    y2: 192.95
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 370.66,
    y1: 187.91,
    x2: 370.52,
    y2: 193.38
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 373.83,
    y1: 187.05,
    x2: 373.55,
    y2: 192.66
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 365.05,
    cy: 179.7,
    r: 1.01
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 367.21,
    cy: 183.45,
    r: 1.01
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 369.94,
    cy: 178.69,
    r: 1.01
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m371.96,183.16c0,.56-.45,1.01-1.01,1.01-.56,0-1.01-.45-1.01-1.01s.45-1.01,1.01-1.01,1.01.45,1.01,1.01h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m368.93,180.71c0,.56-.46,1.01-1.01,1.01-.55,0-1-.45-1.01-1.01,0-.56.45-1.01,1.01-1.01.56,0,1.01.45,1.01,1.01h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m365.19,183.02c0,.56-.45,1.01-1.01,1.01-.56,0-1.01-.45-1.01-1.01s.45-1.01,1.01-1.01,1.01.45,1.01,1.01h0Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 372.39,
    cy: 180.71,
    r: 1.01
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 376.85,
    cy: 181.87,
    r: 1.01
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m375.84,179.41c0,.56-.44,1.02-1,1.02s-1.02-.44-1.02-.99c0-.56.44-1.02,1-1.02,0,0,0,0,.01,0,.55,0,1,.43,1.01.98,0,0,0,0,0,.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m374.83,183.31c0,.56-.45,1.01-1.01,1.01-.56,0-1.01-.45-1.01-1.01s.45-1.01,1.01-1.01,1.01.45,1.01,1.01h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m355.11,193.91h0c-2.54,1.31-5.55,1.37-8.14.17l-.4-.18c-.87-.41-1.46-1.24-1.56-2.2l-.84-8.68h13.25l-.86,8.75c-.08.92-.63,1.72-1.45,2.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m348.45,177.5c-2.24.14-4.36,1.09-5.94,2.68-2.21,2.54,2.11,6.11,5.89,6.69,3.77.58,9.2-.37,10.71-2.17,1.51-1.8,1.13-4.08-1.69-5.98-2.82-1.91-6.81-1.45-8.97-1.22Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 347.48,
    y1: 187.33,
    x2: 347.77,
    y2: 192.95
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 351.66,
    y1: 187.91,
    x2: 351.52,
    y2: 193.38
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 354.82,
    y1: 187.05,
    x2: 354.53,
    y2: 192.66
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m347.06,179.7c0,.56-.45,1.01-1.01,1.01-.56,0-1.01-.45-1.01-1.01s.45-1.01,1.01-1.01,1.01.45,1.01,1.01h0Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 348.2,
    cy: 183.45,
    r: 1.01
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 350.94,
    cy: 178.69,
    r: 1.01
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 351.95,
    cy: 183.16,
    r: 1.01
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m349.93,180.71c0,.56-.45,1.01-1.01,1.01-.56,0-1.01-.45-1.01-1.01s.45-1.01,1.01-1.01,1.01.45,1.01,1.01h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m346.18,183.02c0,.56-.45,1.01-1.01,1.01-.56,0-1.01-.45-1.01-1.01s.45-1.01,1.01-1.01,1.01.45,1.01,1.01h0Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 353.39,
    cy: 180.71,
    r: 1.01
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 357.85,
    cy: 181.87,
    r: 1.01
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m356.84,179.41c0,.56-.44,1.02-1,1.02s-1.02-.44-1.02-.99c0-.56.44-1.02,1-1.02,0,0,0,0,.01,0,.55,0,1,.44,1.01,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m355.83,183.31c0,.56-.45,1.01-1.01,1.01-.56,0-1.01-.45-1.01-1.01s.45-1.01,1.01-1.01,1.01.45,1.01,1.01h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m336.1,193.91h0c-2.54,1.31-5.54,1.37-8.13.17l-.4-.18c-.87-.41-1.46-1.24-1.56-2.2l-.84-8.68h13.25l-.86,8.75c-.08.92-.64,1.73-1.46,2.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m329.43,177.5c-2.24.14-4.35,1.09-5.94,2.68-2.2,2.54,2.13,6.11,5.9,6.69,3.77.58,9.2-.37,10.71-2.17,1.51-1.8,1.13-4.08-1.69-5.98-2.82-1.91-6.83-1.45-8.98-1.22Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 328.48,
    y1: 187.33,
    x2: 328.77,
    y2: 192.95
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 332.65,
    y1: 187.91,
    x2: 332.52,
    y2: 193.38
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 335.82,
    y1: 187.05,
    x2: 335.53,
    y2: 192.66
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 327.04,
    cy: 179.7,
    r: 1.01
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 329.2,
    cy: 183.45,
    r: 1.01
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m332.94,178.69c0,.56-.45,1.01-1.01,1.01-.56,0-1.01-.45-1.01-1.01,0-.56.45-1.01,1.01-1.01s1.01.45,1.01,1.01h0Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 332.94,
    cy: 183.16,
    r: 1.01
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m330.93,180.71c0,.56-.45,1.01-1.01,1.01-.56,0-1.01-.45-1.01-1.01,0-.56.45-1.01,1.01-1.01h0c.56,0,1.01.45,1.01,1.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m327.18,183.02c0,.56-.45,1.01-1.01,1.01-.56,0-1.01-.45-1.01-1.01,0-.56.45-1.01,1.01-1.01h0c.56,0,1.01.45,1.01,1.01Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 334.38,
    cy: 180.71,
    r: 1.01
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 338.85,
    cy: 181.87,
    r: 1.01
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m337.84,179.41c0,.56-.44,1.02-1,1.02s-1.02-.44-1.02-.99c0-.56.44-1.02,1-1.02,0,0,0,0,.01,0,.55,0,1,.44,1.01,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m336.79,183.31c0,.56-.45,1.01-1.01,1.01-.56,0-1.01-.45-1.01-1.01s.45-1.01,1.01-1.01,1.01.45,1.01,1.01h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m381.32,204.43h0c-2.55,1.3-5.54,1.36-8.14.17l-.4-.19c-.87-.41-1.46-1.24-1.56-2.2l-.84-8.68h13.25l-.86,8.75c-.09.92-.64,1.72-1.45,2.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m374.64,188.01c-2.25.16-4.37,1.14-5.94,2.76-2.2,2.53,2.13,6.11,5.9,6.68,3.77.57,9.2-.37,10.71-2.16s1.13-4.15-1.69-5.98c-2.82-1.84-6.76-1.53-8.98-1.3Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 373.69,
    y1: 197.85,
    x2: 373.98,
    y2: 203.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 377.86,
    y1: 198.43,
    x2: 377.72,
    y2: 203.89
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 381.03,
    y1: 197.56,
    x2: 380.74,
    y2: 203.17
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m373.26,190.22c0,.56-.45,1.01-1.01,1.01-.56,0-1.01-.45-1.01-1.01s.45-1.01,1.01-1.01,1.01.45,1.01,1.01h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m375.48,193.99c0,.56-.45,1.01-1.01,1.01-.56,0-1.01-.45-1.01-1.01s.45-1.01,1.01-1.01,1.01.45,1.01,1.01h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m378.15,189.21c0,.56-.45,1.01-1.01,1.01-.56,0-1.01-.45-1.01-1.01s.45-1.01,1.01-1.01,1.01.45,1.01,1.01h0Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 378.15,
    cy: 193.67,
    r: 1.01
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m376.13,191.23c0,.56-.45,1.01-1.01,1.01-.56,0-1.01-.45-1.01-1.01s.45-1.01,1.01-1.01,1.01.45,1.01,1.01h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m372.39,193.52c0,.56-.45,1.01-1.01,1.01-.56,0-1.01-.45-1.01-1.01h0c0-.56.45-1.02,1.01-1.02.56,0,1.01.45,1.01,1.01h0Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 379.59,
    cy: 191.23,
    r: 1.01
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 384.05,
    cy: 192.37,
    r: 1.01
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m383.04,189.93c0,.56-.45,1.01-1.01,1.01-.56,0-1.01-.45-1.01-1.01s.45-1.01,1.01-1.01,1.01.45,1.01,1.01h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m382.04,193.81c0,.56-.45,1.01-1.01,1.01-.56,0-1.01-.45-1.01-1.01s.45-1.01,1.01-1.01,1.01.45,1.01,1.01h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m362.3,204.43h0c-2.54,1.3-5.54,1.36-8.13.17l-.4-.19c-.87-.41-1.46-1.24-1.56-2.2l-.84-8.68h13.25l-.86,8.75c-.1.92-.65,1.73-1.46,2.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m355.64,188.01c-2.25.16-4.37,1.14-5.94,2.76-2.2,2.53,2.13,6.11,5.89,6.68,3.76.57,9.22-.37,10.72-2.16s1.13-4.15-1.69-5.98c-2.82-1.84-6.83-1.53-8.98-1.3Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 354.68,
    y1: 197.85,
    x2: 354.97,
    y2: 203.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 358.86,
    y1: 198.43,
    x2: 358.72,
    y2: 203.89
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 362.02,
    y1: 197.56,
    x2: 361.73,
    y2: 203.17
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m354.26,190.22c0,.56-.45,1.01-1.01,1.01-.56,0-1.01-.45-1.01-1.01s.45-1.01,1.01-1.01,1.01.45,1.01,1.01h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m356.41,193.99c0,.56-.45,1.01-1.01,1.01-.56,0-1.01-.45-1.01-1.01s.45-1.01,1.01-1.01,1.01.45,1.01,1.01h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m359.15,189.21c0,.56-.45,1.01-1.01,1.01-.56,0-1.01-.45-1.01-1.01s.45-1.01,1.01-1.01,1.01.45,1.01,1.01h0Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 359.15,
    cy: 193.67,
    r: 1.01
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 356.12,
    cy: 191.23,
    r: 1.01
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m353.37,193.52c0,.56-.45,1.01-1.01,1.01-.56,0-1.01-.45-1.01-1.01s.45-1.01,1.01-1.01,1.01.45,1.01,1.01h0Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 360.59,
    cy: 191.23,
    r: 1.01
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 365.05,
    cy: 192.37,
    r: 1.01
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m364.04,189.93c0,.56-.45,1.01-1.01,1.01-.56,0-1.01-.45-1.01-1.01s.45-1.01,1.01-1.01,1.01.45,1.01,1.01h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m363.05,193.81c0,.56-.45,1.01-1.01,1.01-.56,0-1.01-.45-1.01-1.01s.45-1.01,1.01-1.01,1.01.45,1.01,1.01h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m343.3,204.43h0c-2.54,1.3-5.54,1.36-8.13.17l-.4-.19c-.87-.41-1.46-1.24-1.56-2.2l-.84-8.68h13.25l-.86,8.75c-.1.92-.65,1.73-1.46,2.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m336.63,188.01c-2.25.16-4.37,1.14-5.94,2.76-2.2,2.53,2.13,6.11,5.89,6.68,3.76.57,9.22-.37,10.72-2.16,1.51-1.78,1.13-4.15-1.69-5.98-2.82-1.84-6.83-1.53-8.98-1.3Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 335.68,
    y1: 197.85,
    x2: 335.97,
    y2: 203.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 339.85,
    y1: 198.43,
    x2: 339.7,
    y2: 203.89
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 343.02,
    y1: 197.56,
    x2: 342.73,
    y2: 203.17
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m335.25,190.22c0,.56-.45,1.01-1.01,1.01-.56,0-1.01-.45-1.01-1.01s.45-1.01,1.01-1.01,1.01.45,1.01,1.01h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m337.41,193.99c0,.56-.45,1.01-1.01,1.01-.56,0-1.01-.45-1.01-1.01s.45-1.01,1.01-1.01,1.01.45,1.01,1.01h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m340.14,189.21c0,.56-.45,1.01-1.01,1.01-.56,0-1.01-.45-1.01-1.01s.45-1.01,1.01-1.01,1.01.45,1.01,1.01h0Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 340.14,
    cy: 193.67,
    r: 1.01
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 337.12,
    cy: 191.23,
    r: 1.01
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m334.38,193.52c0,.56-.45,1.01-1.01,1.01-.56,0-1.01-.45-1.01-1.01s.45-1.01,1.01-1.01,1.01.45,1.01,1.01h0Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 341.58,
    cy: 191.23,
    r: 1.01
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m347.06,192.37c0,.56-.45,1.01-1.01,1.01-.56,0-1.01-.45-1.01-1.01s.45-1.01,1.01-1.01,1.01.45,1.01,1.01h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m345.08,189.93c0,.56-.45,1.01-1.01,1.01-.56,0-1.01-.45-1.01-1.01s.45-1.01,1.01-1.01,1.01.45,1.01,1.01h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m344.03,193.81c0,.56-.45,1.01-1.01,1.01-.56,0-1.01-.45-1.01-1.01s.45-1.01,1.01-1.01,1.01.45,1.01,1.01h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m388.08,214.93h0c-2.54,1.3-5.54,1.36-8.13.17l-.4-.18c-.87-.41-1.46-1.24-1.56-2.2l-.84-8.68h13.24l-.84,8.75c-.1.91-.65,1.72-1.46,2.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m381.41,198.52c-2.24.14-4.36,1.09-5.94,2.68-2.2,2.54,2.11,6.11,5.89,6.68s9.2-.36,10.72-2.16,1.13-4.15-1.69-5.98-6.83-1.45-8.98-1.22Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 380.46,
    y1: 208.35,
    x2: 380.74,
    y2: 213.98
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 384.63,
    y1: 208.93,
    x2: 384.48,
    y2: 214.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 387.8,
    y1: 208.07,
    x2: 387.51,
    y2: 213.69
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 379.01,
    cy: 200.72,
    r: 1.01
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m382.19,204.47c0,.56-.45,1.01-1.01,1.01-.56,0-1.01-.45-1.01-1.01s.45-1.01,1.01-1.01,1.01.45,1.01,1.01h0Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 383.92,
    cy: 199.71,
    r: 1.01
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 384.91,
    cy: 204.18,
    r: 1.01
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m382.91,201.73c0,.56-.45,1.01-1.01,1.01-.56,0-1.01-.45-1.01-1.01s.45-1.01,1.01-1.01,1.01.45,1.01,1.01h0Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 378.15,
    cy: 204.04,
    r: 1.01
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m387.37,201.73c0,.56-.45,1.01-1.01,1.01-.56,0-1.01-.45-1.01-1.01s.45-1.01,1.01-1.01,1.01.45,1.01,1.01h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m391.83,202.89c0,.56-.45,1.01-1.01,1.01-.56,0-1.01-.45-1.01-1.01s.45-1.01,1.01-1.01,1.01.45,1.01,1.01h0Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 388.81,
    cy: 200.43,
    r: 1.01
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 387.8,
    cy: 204.33,
    r: 1.01
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m369.07,214.93h0c-2.54,1.3-5.54,1.36-8.13.17l-.4-.18c-.87-.41-1.46-1.24-1.56-2.2l-.84-8.68h13.2l-.84,8.75c-.09.9-.63,1.71-1.42,2.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m362.41,198.52c-2.24.14-4.36,1.09-5.94,2.68-2.2,2.54,2.11,6.11,5.89,6.68s9.2-.36,10.72-2.16,1.13-4.15-1.69-5.98-6.83-1.45-8.98-1.22Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 361.44,
    y1: 208.35,
    x2: 361.73,
    y2: 213.98
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 365.63,
    y1: 208.93,
    x2: 365.48,
    y2: 214.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 368.8,
    y1: 208.07,
    x2: 368.51,
    y2: 213.69
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 360.01,
    cy: 200.72,
    r: 1.01
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m363.17,204.47c0,.56-.45,1.01-1.01,1.01s-1.01-.45-1.01-1.01.45-1.01,1.01-1.01c0,0,0,0,.01,0,.55,0,1,.46,1,1.01Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 364.9,
    cy: 199.71,
    r: 1.01
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 365.91,
    cy: 204.18,
    r: 1.01
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m363.9,201.73c0,.56-.45,1.01-1.01,1.01-.56,0-1.01-.45-1.01-1.01s.45-1.01,1.01-1.01,1.01.45,1.01,1.01h0Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 359.15,
    cy: 204.04,
    r: 1.01
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m368.35,201.73c0,.56-.45,1.01-1.01,1.01s-1.01-.45-1.01-1.01.45-1.01,1.01-1.01c0,0,0,0,.01,0,.55,0,1,.46,1,1.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m372.82,202.89c0,.56-.45,1.01-1.01,1.01-.56,0-1.01-.45-1.01-1.01s.45-1.01,1.01-1.01c.55,0,1,.43,1.01.98,0,0,0,.02,0,.03Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 369.8,
    cy: 200.43,
    r: 1.01
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 368.8,
    cy: 204.33,
    r: 1.01
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m350.07,214.93h0c-2.54,1.3-5.54,1.36-8.13.17l-.4-.18c-.87-.41-1.46-1.24-1.56-2.2l-.84-8.68h13.24l-.84,8.75c-.1.91-.65,1.72-1.46,2.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m343.41,198.52c-2.24.14-4.36,1.09-5.94,2.68-2.2,2.54,2.11,6.11,5.89,6.68s9.2-.36,10.72-2.16c1.52-1.8,1.13-4.15-1.69-5.98-2.82-1.84-6.83-1.45-8.98-1.22Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 342.44,
    y1: 208.35,
    x2: 342.73,
    y2: 213.98
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 346.61,
    y1: 208.93,
    x2: 346.47,
    y2: 214.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 349.79,
    y1: 208.07,
    x2: 349.5,
    y2: 213.69
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 341,
    cy: 200.72,
    r: 1.01
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m344.17,204.47c0,.56-.45,1.01-1.01,1.01-.56,0-1.01-.45-1.01-1.01s.45-1.01,1.01-1.01,1.01.45,1.01,1.01h0Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 345.89,
    cy: 199.71,
    r: 1.01
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m347.91,204.18c0,.56-.46,1.01-1.01,1.01-.55,0-1-.45-1.01-1.01,0-.56.46-1.01,1.01-1.01.55,0,1,.45,1.01,1.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m344.89,201.73c0,.56-.45,1.01-1.01,1.01s-1.01-.45-1.01-1.01.45-1.01,1.01-1.01c0,0,0,0,.01,0,.55,0,1,.46,1,1.01Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 340.14,
    cy: 204.04,
    r: 1.01
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m349.35,201.73c0,.56-.45,1.01-1.01,1.01-.56,0-1.01-.45-1.01-1.01s.45-1.01,1.01-1.01,1.01.45,1.01,1.01h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m353.81,202.89c0,.56-.46,1.01-1.01,1.01-.55,0-1-.45-1.01-1.01,0-.56.45-1.01,1.01-1.01.56,0,1.01.45,1.01,1.01h0Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 350.8,
    cy: 200.43,
    r: 1.01
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 349.79,
    cy: 204.33,
    r: 1.01
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m395.57,225.45h0c-2.54,1.3-5.54,1.36-8.13.17l-.41-.19c-.87-.4-1.46-1.24-1.55-2.2l-.84-8.68h13.24l-.84,8.75c-.1.92-.65,1.73-1.47,2.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m388.9,209.03c-2.25.16-4.37,1.14-5.94,2.76-2.21,2.53,2.11,6.11,5.89,6.68,3.77.57,9.2-.37,10.72-2.17,1.52-1.8,1.12-4.15-1.69-5.97-2.81-1.82-6.83-1.53-8.98-1.3Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 387.94,
    y1: 218.87,
    x2: 388.23,
    y2: 224.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 392.11,
    y1: 219.45,
    x2: 391.97,
    y2: 224.91
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 395.29,
    y1: 218.58,
    x2: 395,
    y2: 224.19
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m387.51,211.24c0,.56-.45,1.01-1.01,1.01-.56,0-1.01-.45-1.01-1.01s.45-1.01,1.01-1.01,1.01.45,1.01,1.01h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m389.66,214.98c0,.56-.46,1.01-1.01,1.01-.55,0-1-.45-1.01-1.01,0-.56.45-1.01,1.01-1.01.56,0,1.01.45,1.01,1.01h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m392.4,210.23c0,.56-.45,1.01-1.01,1.01-.56,0-1.01-.45-1.01-1.01s.45-1.01,1.01-1.01,1.01.45,1.01,1.01h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m393.45,214.72c0,.56-.45,1.01-1.01,1.01-.56,0-1.01-.45-1.01-1.01s.45-1.01,1.01-1.01,1.01.45,1.01,1.01h0Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 389.37,
    cy: 212.25,
    r: 1.01
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 385.64,
    cy: 214.54,
    r: 1.01
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 393.84,
    cy: 212.25,
    r: 1.01
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m399.31,213.34c0,.56-.45,1.01-1.01,1.01-.56,0-1.01-.45-1.01-1.01s.45-1.01,1.01-1.01,1.01.45,1.01,1.01h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m397.29,210.95c0,.56-.45,1.01-1.01,1.01-.56,0-1.01-.45-1.01-1.01s.45-1.01,1.01-1.01,1.01.45,1.01,1.01h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m396.28,214.83c0,.56-.45,1.01-1.01,1.01s-1.01-.45-1.01-1.01.45-1.01,1.01-1.01c0,0,0,0,.01,0,.55,0,1,.46,1,1.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m376.56,225.45h0c-2.54,1.3-5.54,1.36-8.13.17l-.41-.19c-.87-.4-1.46-1.24-1.55-2.2l-.84-8.68h13.24l-.86,8.75c-.09.92-.64,1.72-1.45,2.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m369.96,209.03c-2.25.16-4.37,1.14-5.94,2.76-2.21,2.53,2.11,6.11,5.89,6.68,3.77.57,9.2-.37,10.71-2.17,1.51-1.8,1.13-4.15-1.67-5.97-2.81-1.82-6.9-1.53-8.98-1.3Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 368.93,
    y1: 218.87,
    x2: 369.22,
    y2: 224.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 373.11,
    y1: 219.45,
    x2: 372.97,
    y2: 224.91
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 376.27,
    y1: 218.58,
    x2: 376,
    y2: 224.19
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 367.5,
    cy: 211.24,
    r: 1.01
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m370.66,214.98c0,.56-.46,1.01-1.01,1.01-.55,0-1-.45-1.01-1.01,0-.56.45-1.01,1.01-1.01.56,0,1.01.45,1.01,1.01h0Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 372.39,
    cy: 210.23,
    r: 1.01
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m374.41,214.72c0,.56-.45,1.01-1.01,1.01-.56,0-1.01-.45-1.01-1.01s.45-1.01,1.01-1.01,1.01.45,1.01,1.01h0Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 370.37,
    cy: 212.25,
    r: 1.01
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 366.63,
    cy: 214.54,
    r: 1.01
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 374.83,
    cy: 212.25,
    r: 1.01
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m380.31,213.34c0,.56-.45,1.01-1.01,1.01-.56,0-1.01-.45-1.01-1.01s.45-1.01,1.01-1.01,1.01.45,1.01,1.01h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m378.25,210.95c0,.56-.45,1.01-1.01,1.01-.56,0-1.01-.45-1.01-1.01s.45-1.01,1.01-1.01,1.01.45,1.01,1.01h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m377.28,214.83c0,.56-.45,1.01-1.01,1.01-.56,0-1.01-.45-1.01-1.01s.45-1.01,1.01-1.01,1.01.45,1.01,1.01h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m357.52,225.45h0c-2.54,1.3-5.54,1.36-8.13.17l-.41-.19c-.87-.41-1.46-1.24-1.56-2.2l-.84-8.68h13.25l-.86,8.75c-.09.92-.64,1.72-1.45,2.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m350.9,209.03c-2.25.16-4.37,1.14-5.94,2.76-2.21,2.53,2.11,6.11,5.89,6.68,3.77.57,9.2-.37,10.71-2.17s1.13-4.15-1.67-5.97-6.84-1.53-8.98-1.3Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 349.93,
    y1: 218.87,
    x2: 350.22,
    y2: 224.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 354.1,
    y1: 219.45,
    x2: 353.97,
    y2: 224.91
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 357.27,
    y1: 218.58,
    x2: 356.99,
    y2: 224.19
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 348.49,
    cy: 211.24,
    r: 1.01
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 350.65,
    cy: 214.98,
    r: 1.01
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 353.39,
    cy: 210.23,
    r: 1.01
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m355.4,214.72c0,.56-.45,1.01-1.01,1.01-.56,0-1.01-.45-1.01-1.01s.45-1.01,1.01-1.01,1.01.45,1.01,1.01h0Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 351.37,
    cy: 212.25,
    r: 1.01
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 347.62,
    cy: 214.54,
    r: 1.01
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 355.83,
    cy: 212.25,
    r: 1.01
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m361.3,213.34c0,.56-.45,1.01-1.01,1.01-.56,0-1.01-.45-1.01-1.01s.45-1.01,1.01-1.01,1.01.45,1.01,1.01h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m359.29,210.95c0,.56-.45,1.01-1.01,1.01-.56,0-1.01-.45-1.01-1.01s.45-1.01,1.01-1.01,1.01.45,1.01,1.01h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m358.28,214.83c0,.56-.45,1.01-1.01,1.01-.56,0-1.01-.45-1.01-1.01s.45-1.01,1.01-1.01,1.01.45,1.01,1.01h0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 347.21,
    y: 222.97,
    width: 60.51,
    height: 6.54
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "347.21 229.51 315.85 185.6 315.85 179.08 347.21 222.97 347.21 229.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "311.15 185.6 342.51 229.51 282 229.51 250.64 185.6 311.15 185.6"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 250.64,
    y: 179.08,
    width: 60.51,
    height: 6.54
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "342.51 229.51 311.15 185.6 311.15 179.08 342.51 222.97 342.51 229.51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m309.14,193.91h0c-2.54,1.31-5.54,1.37-8.13.17l-.4-.18c-.87-.41-1.46-1.24-1.56-2.2l-.84-8.68h13.25l-.86,8.75c-.08.92-.64,1.73-1.46,2.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m302.51,177.5c-2.24.14-4.35,1.09-5.94,2.68-2.2,2.54,2.13,6.11,5.89,6.69,3.76.58,9.22-.37,10.72-2.17,1.51-1.8,1.13-4.08-1.69-5.98s-6.83-1.45-8.98-1.22Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 301.56,
    y1: 187.33,
    x2: 301.85,
    y2: 192.95
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 305.73,
    y1: 187.91,
    x2: 305.59,
    y2: 193.38
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 308.9,
    y1: 187.05,
    x2: 308.61,
    y2: 192.66
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 300.12,
    cy: 179.7,
    r: 1.01
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m303.28,183.45c0,.56-.45,1.01-1.01,1.01-.56,0-1.01-.45-1.01-1.01,0-.56.45-1.01,1.01-1.01h0c.56,0,1.01.45,1.01,1.01Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 305.01,
    cy: 178.69,
    r: 1.01
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m307.03,183.16c0,.56-.45,1.01-1.01,1.01-.56,0-1.01-.45-1.01-1.01,0-.56.45-1.01,1.01-1.01h0c.56,0,1.01.45,1.01,1.01Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 302.99,
    cy: 180.71,
    r: 1.01
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 299.25,
    cy: 183.02,
    r: 1.01
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 307.46,
    cy: 180.71,
    r: 1.01
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m312.93,181.87c0,.56-.45,1.01-1.01,1.01-.56,0-1.01-.45-1.01-1.01,0-.56.45-1.01,1.01-1.01h0c.56,0,1.01.45,1.01,1.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m310.91,179.41c0,.56-.44,1.02-1,1.02-.56,0-1.02-.44-1.02-.99,0-.56.44-1.02,1-1.02,0,0,0,0,.01,0,.55,0,1,.44,1.01,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m309.91,183.31c0,.56-.45,1.01-1.01,1.01-.56,0-1.01-.45-1.01-1.01,0-.56.45-1.01,1.01-1.01h0c.56,0,1.01.45,1.01,1.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m290.17,193.91h0c-2.54,1.31-5.54,1.37-8.13.17l-.4-.18c-.87-.41-1.46-1.24-1.56-2.2l-.84-8.68h13.32l-.86,8.75c-.1.93-.68,1.75-1.53,2.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m283.51,177.5c-2.24.14-4.35,1.09-5.94,2.68-2.2,2.54,2.13,6.11,5.89,6.69,3.76.58,9.22-.37,10.72-2.17s1.15-4.08-1.62-5.92-6.91-1.52-9.05-1.29Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 282.55,
    y1: 187.33,
    x2: 282.84,
    y2: 192.95
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 286.73,
    y1: 187.91,
    x2: 286.58,
    y2: 193.38
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 289.89,
    y1: 187.05,
    x2: 289.6,
    y2: 192.66
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 281.12,
    cy: 179.7,
    r: 1.01
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 283.27,
    cy: 183.45,
    r: 1.01
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 286.01,
    cy: 178.69,
    r: 1.01
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m288.03,183.16c0,.56-.45,1.01-1.01,1.01-.56,0-1.01-.45-1.01-1.01,0-.56.45-1.01,1.01-1.01h0c.56,0,1.01.45,1.01,1.01Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 283.99,
    cy: 180.71,
    r: 1.01
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 280.25,
    cy: 183.02,
    r: 1.01
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 288.46,
    cy: 180.71,
    r: 1.01
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m293.94,181.87c0,.56-.45,1.01-1.01,1.01-.56,0-1.01-.45-1.01-1.01,0-.56.45-1.01,1.01-1.01h0c.56,0,1.01.45,1.01,1.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m291.91,179.41c0,.56-.44,1.02-1,1.02-.56,0-1.02-.44-1.02-.99,0-.56.44-1.02,1-1.02,0,0,0,0,.01,0,.55,0,1,.44,1.01,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m290.9,183.31c0,.56-.45,1.01-1.01,1.01-.56,0-1.01-.45-1.01-1.01,0-.56.45-1.01,1.01-1.01h0c.56,0,1.01.45,1.01,1.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m271.17,193.91h0c-2.54,1.31-5.54,1.37-8.13.17l-.4-.18c-.87-.41-1.46-1.24-1.56-2.2l-.84-8.68h13.24l-.84,8.75c-.1.91-.65,1.72-1.46,2.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m264.5,177.5c-2.24.14-4.35,1.09-5.94,2.68-2.2,2.54,2.13,6.11,5.89,6.69,3.76.58,9.2-.37,10.72-2.17,1.52-1.8,1.13-4.08-1.69-5.98-2.82-1.91-6.83-1.45-8.98-1.22Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 263.55,
    y1: 187.33,
    x2: 263.83,
    y2: 192.95
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 267.72,
    y1: 187.91,
    x2: 267.57,
    y2: 193.38
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 270.89,
    y1: 187.05,
    x2: 270.6,
    y2: 192.66
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 262.1,
    cy: 179.7,
    r: 1.01
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 264.27,
    cy: 183.45,
    r: 1.01
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 267.01,
    cy: 178.69,
    r: 1.01
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m269.06,183.16c0,.56-.45,1.01-1.01,1.01-.56,0-1.01-.45-1.01-1.01,0-.56.45-1.01,1.01-1.01h0c.56,0,1.01.45,1.01,1.01Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 264.99,
    cy: 180.71,
    r: 1.01
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 261.24,
    cy: 183.02,
    r: 1.01
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 269.45,
    cy: 180.71,
    r: 1.01
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m274.92,181.87c0,.56-.45,1.01-1.01,1.01-.56,0-1.01-.45-1.01-1.01,0-.56.45-1.01,1.01-1.01h0c.56,0,1.01.45,1.01,1.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m272.91,179.41c0,.56-.44,1.02-1,1.02-.56,0-1.02-.44-1.02-.99,0-.56.44-1.02,1-1.02,0,0,0,0,.01,0,.55,0,1,.44,1.01,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m271.9,183.31c0,.56-.45,1.01-1.01,1.01-.56,0-1.01-.45-1.01-1.01,0-.56.45-1.01,1.01-1.01h0c.56,0,1.01.45,1.01,1.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m316.37,204.43h0c-2.54,1.3-5.54,1.36-8.13.17l-.4-.19c-.87-.41-1.46-1.24-1.56-2.2l-.84-8.68h13.24l-.84,8.75c-.1.92-.65,1.73-1.46,2.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m309.71,188.01c-2.25.16-4.37,1.14-5.94,2.76-2.2,2.53,2.13,6.11,5.89,6.68,3.76.57,9.22-.37,10.72-2.16,1.51-1.78,1.13-4.15-1.69-5.98-2.82-1.84-6.79-1.53-8.98-1.3Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 308.76,
    y1: 197.85,
    x2: 309.05,
    y2: 203.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 312.93,
    y1: 198.43,
    x2: 312.78,
    y2: 203.89
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 316.1,
    y1: 197.56,
    x2: 315.81,
    y2: 203.17
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 307.32,
    cy: 190.22,
    r: 1.01
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 309.48,
    cy: 193.96,
    r: 1.01
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m313.29,189.21c0,.56-.45,1.01-1.01,1.01-.56,0-1.01-.45-1.01-1.01,0-.56.45-1.01,1.01-1.01h0c.56,0,1.01.45,1.01,1.01Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 313.22,
    cy: 193.67,
    r: 1.01
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 310.2,
    cy: 191.23,
    r: 1.01
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m307.46,193.52c0,.56-.45,1.01-1.01,1.01-.56,0-1.01-.45-1.01-1.01,0-.56.45-1.01,1.01-1.01h0c.56,0,1.01.45,1.01,1.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m315.67,191.23c0,.56-.45,1.01-1.01,1.01-.56,0-1.01-.45-1.01-1.01,0-.56.45-1.01,1.01-1.01h0c.56,0,1.01.45,1.01,1.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m320.2,192.37c0,.56-.45,1.01-1.01,1.01-.56,0-1.01-.45-1.01-1.01,0-.56.45-1.01,1.01-1.01h0c.56,0,1.01.45,1.01,1.01Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 317.11,
    cy: 189.93,
    r: 1.01
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 316.1,
    cy: 193.81,
    r: 1.01
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m297.37,204.43h0c-2.54,1.3-5.54,1.36-8.13.17l-.4-.19c-.87-.41-1.46-1.24-1.56-2.2l-.84-8.68h13.24l-.84,8.75c-.1.92-.65,1.73-1.46,2.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m290.71,188.01c-2.25.16-4.37,1.14-5.94,2.76-2.2,2.53,2.13,6.11,5.89,6.68,3.76.57,9.2-.37,10.72-2.16,1.52-1.78,1.13-4.15-1.69-5.98-2.82-1.84-6.83-1.53-8.98-1.3Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 289.75,
    y1: 197.85,
    x2: 290.03,
    y2: 203.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 293.93,
    y1: 198.43,
    x2: 293.78,
    y2: 203.89
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 297.09,
    y1: 197.56,
    x2: 296.8,
    y2: 203.17
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 288.3,
    cy: 190.22,
    r: 1.01
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m291.48,193.99c0,.56-.45,1.01-1.01,1.01s-1.01-.45-1.01-1.01.45-1.01,1.01-1.01,1.01.45,1.01,1.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m294.22,189.21c0,.56-.45,1.01-1.01,1.01-.56,0-1.01-.45-1.01-1.01,0-.56.45-1.01,1.01-1.01h0c.56,0,1.01.45,1.01,1.01Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 294.22,
    cy: 193.67,
    r: 1.01
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 291.19,
    cy: 191.23,
    r: 1.01
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m288.41,193.52c0,.56-.45,1.01-1.01,1.01-.56,0-1.01-.45-1.01-1.01,0-.56.45-1.01,1.01-1.01h0c.56,0,1.01.45,1.01,1.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m296.71,191.23c0,.56-.45,1.01-1.01,1.01s-1.01-.45-1.01-1.01.45-1.01,1.01-1.01,1.01.45,1.01,1.01Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 300.12,
    cy: 192.37,
    r: 1.01
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 298.1,
    cy: 189.93,
    r: 1.01
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m298.09,193.81c0,.56-.45,1.01-1.01,1.01-.56,0-1.01-.45-1.01-1.01,0-.56.45-1.01,1.01-1.01h0c.56,0,1.01.45,1.01,1.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m278.37,204.43h0c-2.54,1.3-5.54,1.36-8.13.17l-.4-.19c-.87-.41-1.46-1.24-1.56-2.2l-.84-8.68h13.24l-.84,8.75c-.1.92-.65,1.73-1.46,2.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m271.7,188.01c-2.25.16-4.37,1.14-5.94,2.76-2.2,2.53,2.11,6.11,5.89,6.68,3.77.57,9.2-.37,10.72-2.16s1.13-4.15-1.69-5.98c-2.82-1.84-6.83-1.53-8.98-1.3Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 270.75,
    y1: 197.85,
    x2: 271.03,
    y2: 203.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 274.92,
    y1: 198.43,
    x2: 274.77,
    y2: 203.89
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 278.09,
    y1: 197.56,
    x2: 277.8,
    y2: 203.17
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 269.3,
    cy: 190.22,
    r: 1.01
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 271.47,
    cy: 193.96,
    r: 1.01
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m275.2,189.21c0,.56-.45,1.01-1.01,1.01s-1.01-.45-1.01-1.01c0-.56.45-1.01,1.01-1.01,0,0,0,0,.01,0,.55,0,1,.46,1,1.01Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 275.2,
    cy: 193.67,
    r: 1.01
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 272.19,
    cy: 191.23,
    r: 1.01
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m269.45,193.52c0,.56-.45,1.01-1.01,1.01-.56,0-1.01-.45-1.01-1.01,0-.56.45-1.01,1.01-1.01h0c.56,0,1.01.45,1.01,1.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m277.66,191.23c0,.56-.45,1.01-1.01,1.01s-1.01-.45-1.01-1.01.45-1.01,1.01-1.01,1.01.45,1.01,1.01Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 281.12,
    cy: 192.37,
    r: 1.01
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 279.1,
    cy: 189.93,
    r: 1.01
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 278.09,
    cy: 193.81,
    r: 1.01
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m323.15,214.93h0c-2.54,1.3-5.54,1.36-8.13.17l-.4-.18c-.87-.41-1.46-1.24-1.56-2.2l-.84-8.68h13.24l-.84,8.75c-.1.91-.65,1.72-1.46,2.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m316.48,198.52c-2.24.14-4.36,1.09-5.94,2.68-2.21,2.54,2.11,6.11,5.89,6.68s9.2-.36,10.72-2.16,1.12-4.15-1.69-5.98-6.83-1.45-8.98-1.22Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 315.52,
    y1: 208.35,
    x2: 315.81,
    y2: 213.98
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 319.69,
    y1: 208.93,
    x2: 319.55,
    y2: 214.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 322.87,
    y1: 208.07,
    x2: 322.58,
    y2: 213.69
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m315.09,200.72c0,.56-.45,1.01-1.01,1.01-.56,0-1.01-.45-1.01-1.01,0-.56.45-1.01,1.01-1.01h0c.56,0,1.01.45,1.01,1.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m317.24,204.47c0,.56-.45,1.01-1.01,1.01-.56,0-1.01-.45-1.01-1.01,0-.56.45-1.01,1.01-1.01h0c.56,0,1.01.45,1.01,1.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m319.98,199.71c0,.56-.45,1.01-1.01,1.01s-1.01-.45-1.01-1.01.45-1.01,1.01-1.01,1.01.45,1.01,1.01h0Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 319.98,
    cy: 204.18,
    r: 1.01
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m317.96,201.73c0,.56-.45,1.01-1.01,1.01-.56,0-1.01-.45-1.01-1.01,0-.56.45-1.01,1.01-1.01h0c.56,0,1.01.45,1.01,1.01Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 313.22,
    cy: 204.04,
    r: 1.01
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m322.43,201.73c0,.56-.45,1.01-1.01,1.01-.56,0-1.01-.45-1.01-1.01,0-.56.45-1.01,1.01-1.01h0c.56,0,1.01.45,1.01,1.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m326.89,202.89c0,.56-.45,1.01-1.01,1.01-.56,0-1.01-.45-1.01-1.01s.45-1.01,1.01-1.01,1.01.45,1.01,1.01h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m324.87,200.43c0,.56-.44,1.01-1,1.02-.56,0-1.01-.44-1.02-1,0-.56.44-1.01,1-1.02,0,0,.02,0,.03,0,.55,0,1,.45,1,1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m323.88,204.33c0,.56-.45,1.01-1.01,1.01s-1.01-.45-1.01-1.01.45-1.01,1.01-1.01,1.01.45,1.01,1.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m304.14,214.93h0c-2.54,1.3-5.54,1.36-8.13.17l-.41-.18c-.86-.42-1.45-1.25-1.55-2.2l-.84-8.68h13.24l-.84,8.75c-.1.91-.65,1.72-1.46,2.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m297.48,198.52c-2.24.14-4.36,1.09-5.94,2.68-2.21,2.54,2.11,6.11,5.89,6.68s9.2-.36,10.72-2.16,1.12-4.15-1.69-5.98c-2.81-1.84-6.84-1.45-8.98-1.22Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 296.51,
    y1: 208.35,
    x2: 296.8,
    y2: 213.98
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 300.69,
    y1: 208.93,
    x2: 300.55,
    y2: 214.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 303.87,
    y1: 208.07,
    x2: 303.58,
    y2: 213.69
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m296.08,200.72c0,.56-.45,1.01-1.01,1.01-.56,0-1.01-.45-1.01-1.01,0-.56.45-1.01,1.01-1.01h0c.56,0,1.01.45,1.01,1.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m298.24,204.47c0,.56-.45,1.01-1.01,1.01-.56,0-1.01-.45-1.01-1.01,0-.56.45-1.01,1.01-1.01h0c.56,0,1.01.45,1.01,1.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m300.98,199.71c0,.56-.45,1.01-1.01,1.01s-1.01-.45-1.01-1.01.45-1.01,1.01-1.01,1.01.45,1.01,1.01h0Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 300.98,
    cy: 204.18,
    r: 1.01
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m298.96,201.73c0,.56-.45,1.01-1.01,1.01-.56,0-1.01-.45-1.01-1.01,0-.56.45-1.01,1.01-1.01h0c.56,0,1.01.45,1.01,1.01Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 294.22,
    cy: 204.04,
    r: 1.01
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m303.42,201.73c0,.56-.45,1.01-1.01,1.01-.56,0-1.01-.45-1.01-1.01,0-.56.45-1.01,1.01-1.01h0c.56,0,1.01.45,1.01,1.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m307.89,202.89c0,.56-.45,1.01-1.01,1.01-.56,0-1.01-.45-1.01-1.01s.45-1.01,1.01-1.01,1.01.45,1.01,1.01h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m305.87,200.43c0,.56-.44,1.02-1,1.02-.56,0-1.02-.44-1.02-.99,0-.56.44-1.02,1-1.02,0,0,0,0,.01,0,.55,0,1,.43,1.01.98,0,0,0,0,0,.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m304.86,204.33c0,.56-.45,1.01-1.01,1.01s-1.01-.45-1.01-1.01c0-.56.45-1.01,1.01-1.01,0,0,0,0,.01,0,.55,0,1,.46,1,1.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m285.14,214.93h0c-2.54,1.3-5.54,1.36-8.13.17l-.41-.18c-.86-.42-1.45-1.25-1.55-2.2l-.84-8.68h13.24l-.86,8.75c-.08.92-.63,1.72-1.45,2.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m278.48,198.52c-2.24.14-4.36,1.09-5.94,2.68-2.21,2.54,2.11,6.11,5.89,6.68s9.2-.36,10.71-2.16c1.51-1.8,1.13-4.15-1.67-5.98-2.81-1.84-6.84-1.45-8.98-1.22Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 277.51,
    y1: 208.35,
    x2: 277.8,
    y2: 213.98
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 281.68,
    y1: 208.93,
    x2: 281.54,
    y2: 214.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 284.85,
    y1: 208.07,
    x2: 284.57,
    y2: 213.69
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m277.08,200.72c0,.56-.45,1.01-1.01,1.01-.56,0-1.01-.45-1.01-1.01,0-.56.45-1.01,1.01-1.01h0c.56,0,1.01.45,1.01,1.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m279.24,204.47c0,.56-.45,1.01-1.01,1.01-.56,0-1.01-.45-1.01-1.01,0-.56.45-1.01,1.01-1.01h0c.56,0,1.01.45,1.01,1.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m281.97,199.71c0,.56-.45,1.01-1.01,1.01-.56,0-1.01-.45-1.01-1.01,0-.56.45-1.01,1.01-1.01h0c.56,0,1.01.45,1.01,1.01Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 281.97,
    cy: 204.18,
    r: 1.01
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m279.96,201.73c0,.56-.45,1.01-1.01,1.01-.56,0-1.01-.45-1.01-1.01,0-.56.45-1.01,1.01-1.01h0c.56,0,1.01.45,1.01,1.01Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 275.2,
    cy: 204.04,
    r: 1.01
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m284.42,201.73c0,.56-.45,1.01-1.01,1.01-.56,0-1.01-.45-1.01-1.01,0-.56.45-1.01,1.01-1.01h0c.56,0,1.01.45,1.01,1.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m288.88,202.89c0,.56-.45,1.01-1.01,1.01-.56,0-1.01-.45-1.01-1.01,0-.56.45-1.01,1.01-1.01h0c.56,0,1.01.45,1.01,1.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m286.87,200.43c0,.56-.44,1.02-1,1.02-.56,0-1.02-.44-1.02-.99,0-.56.44-1.02,1-1.02,0,0,0,0,.01,0,.55,0,1,.43,1.01.98,0,0,0,0,0,.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m285.86,204.33c0,.56-.45,1.01-1.01,1.01-.56,0-1.01-.45-1.01-1.01,0-.56.45-1.01,1.01-1.01h0c.56,0,1.01.45,1.01,1.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m330.64,225.45h0c-2.54,1.3-5.54,1.36-8.13.17l-.41-.19c-.87-.41-1.46-1.24-1.56-2.2l-.84-8.68h13.25l-.86,8.75c-.09.92-.64,1.72-1.45,2.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m323.97,209.03c-2.25.16-4.37,1.14-5.94,2.76-2.21,2.53,2.11,6.11,5.89,6.68,3.77.57,9.2-.37,10.71-2.17,1.51-1.8,1.13-4.15-1.67-5.97s-6.84-1.53-8.98-1.3Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 323.01,
    y1: 218.87,
    x2: 323.3,
    y2: 224.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 327.18,
    y1: 219.45,
    x2: 327.04,
    y2: 224.91
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 330.35,
    y1: 218.58,
    x2: 330.06,
    y2: 224.19
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 321.57,
    cy: 211.24,
    r: 1.01
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 323.73,
    cy: 214.98,
    r: 1.01
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 326.46,
    cy: 210.23,
    r: 1.01
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m328.49,214.72c0,.56-.45,1.01-1.01,1.01-.56,0-1.01-.45-1.01-1.01,0-.56.45-1.01,1.01-1.01h0c.56,0,1.01.45,1.01,1.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m325.45,212.25c0,.56-.45,1.01-1.01,1.01-.56,0-1.01-.45-1.01-1.01,0-.56.45-1.01,1.01-1.01h0c.56,0,1.01.45,1.01,1.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m321.71,214.54c0,.56-.45,1.01-1.01,1.01s-1.01-.45-1.01-1.01.45-1.01,1.01-1.01,1.01.45,1.01,1.01Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 328.91,
    cy: 212.25,
    r: 1.01
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 333.37,
    cy: 213.39,
    r: 1.01
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m332.36,210.95c0,.56-.45,1.01-1.01,1.01-.56,0-1.01-.45-1.01-1.01,0-.56.45-1.01,1.01-1.01s1.01.45,1.01,1.01h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m331.35,214.83c0,.56-.45,1.01-1.01,1.01-.56,0-1.01-.45-1.01-1.01,0-.56.45-1.01,1.01-1.01h0c.56,0,1.01.45,1.01,1.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m311.63,225.45h0c-2.55,1.3-5.54,1.36-8.14.17l-.4-.19c-.87-.41-1.46-1.24-1.56-2.2l-.84-8.68h13.25l-.86,8.75c-.09.92-.64,1.72-1.45,2.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m305,209.03c-2.25.16-4.37,1.14-5.94,2.76-2.2,2.53,2.13,6.11,5.9,6.68,3.77.57,9.2-.37,10.71-2.17,1.51-1.8,1.13-4.15-1.69-5.97s-6.87-1.53-8.98-1.3Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 304,
    y1: 218.87,
    x2: 304.29,
    y2: 224.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 308.18,
    y1: 219.45,
    x2: 308.04,
    y2: 224.91
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 311.34,
    y1: 218.58,
    x2: 311.05,
    y2: 224.19
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 302.57,
    cy: 211.24,
    r: 1.01
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 304.72,
    cy: 214.98,
    r: 1.01
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 307.46,
    cy: 210.23,
    r: 1.01
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m309.48,214.72c0,.56-.45,1.01-1.01,1.01-.56,0-1.01-.45-1.01-1.01,0-.56.45-1.01,1.01-1.01h0c.56,0,1.01.45,1.01,1.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m306.45,212.25c0,.56-.45,1.01-1.01,1.01-.56,0-1.01-.45-1.01-1.01,0-.56.45-1.01,1.01-1.01h0c.56,0,1.01.45,1.01,1.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m302.7,214.54c0,.56-.45,1.01-1.01,1.01s-1.01-.45-1.01-1.01.45-1.01,1.01-1.01,1.01.45,1.01,1.01Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 309.91,
    cy: 212.25,
    r: 1.01
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 314.37,
    cy: 213.39,
    r: 1.01
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m313.36,210.95c0,.56-.45,1.01-1.01,1.01-.56,0-1.01-.45-1.01-1.01,0-.56.45-1.01,1.01-1.01h0c.56,0,1.01.45,1.01,1.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m312.35,214.83c0,.56-.45,1.01-1.01,1.01-.56,0-1.01-.45-1.01-1.01,0-.56.45-1.01,1.01-1.01h0c.56,0,1.01.45,1.01,1.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m292.56,225.45h0c-2.54,1.3-5.54,1.36-8.13.17l-.4-.19c-.87-.41-1.46-1.24-1.56-2.2l-.84-8.68h13.25l-.86,8.75c-.1.92-.65,1.73-1.46,2.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m285.95,209.03c-2.25.16-4.37,1.14-5.94,2.76-2.2,2.53,2.13,6.11,5.9,6.68,3.77.57,9.2-.37,10.71-2.17,1.51-1.8,1.13-4.15-1.69-5.97-2.82-1.82-6.83-1.53-8.98-1.3Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 285,
    y1: 218.87,
    x2: 285.29,
    y2: 224.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 289.17,
    y1: 219.45,
    x2: 289.04,
    y2: 224.91
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 292.34,
    y1: 218.58,
    x2: 292.05,
    y2: 224.19
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 283.56,
    cy: 211.24,
    r: 1.01
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 285.72,
    cy: 214.98,
    r: 1.01
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 288.46,
    cy: 210.23,
    r: 1.01
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m290.47,214.72c0,.56-.45,1.01-1.01,1.01-.56,0-1.01-.45-1.01-1.01,0-.56.45-1.01,1.01-1.01h0c.56,0,1.01.45,1.01,1.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m287.45,212.25c0,.56-.45,1.01-1.01,1.01-.56,0-1.01-.45-1.01-1.01,0-.56.45-1.01,1.01-1.01h0c.56,0,1.01.45,1.01,1.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m283.7,214.54c0,.56-.45,1.01-1.01,1.01-.56,0-1.01-.45-1.01-1.01,0-.56.45-1.01,1.01-1.01h0c.56,0,1.01.45,1.01,1.01Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 290.9,
    cy: 212.25,
    r: 1.01
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 295.37,
    cy: 213.39,
    r: 1.01
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m294.36,210.95c0,.56-.45,1.01-1.01,1.01-.56,0-1.01-.45-1.01-1.01,0-.56.45-1.01,1.01-1.01h0c.56,0,1.01.45,1.01,1.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m293.35,214.83c0,.56-.45,1.01-1.01,1.01-.56,0-1.01-.45-1.01-1.01,0-.56.45-1.01,1.01-1.01h0c.56,0,1.01.45,1.01,1.01Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 282,
    y: 222.97,
    width: 60.51,
    height: 6.54
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "282 229.51 250.64 185.6 250.64 179.08 282 222.97 282 229.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "245.93 185.6 277.29 229.51 216.78 229.51 185.42 185.6 245.93 185.6"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 185.42,
    y: 179.08,
    width: 60.51,
    height: 6.54
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "277.29 229.51 245.93 185.6 245.93 179.08 277.29 222.97 277.29 229.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "216.78 229.51 185.42 185.6 185.42 179.08 216.78 222.97 216.78 229.51"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 240.73,
    cy: 186.32,
    rx: 9.49,
    ry: 6.47
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m232.5,187.29s-1.09.21,1.64-1.96c2.74-2.17,4.26-1.53,5.89-2.52,1.32-.91,2.87-1.44,4.48-1.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m234.36,189.84c.83-.89,1.88-1.53,3.05-1.85,1.97-.62,3.74-1.75,5.13-3.28,1.5-1.31,3.48-1.94,5.46-1.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m238.82,191.86s2.63-2.18,4.15-3.16c1.16-.74,2.46-1.22,3.83-1.38.96-.32,1.82-.88,2.5-1.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m244.06,185.49c0,.75-1.49,1.38-3.33,1.38s-3.32-.61-3.32-1.38,1.48-1.38,3.32-1.38,3.33.64,3.33,1.38Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 248.26,
    cy: 197.68,
    rx: 9.49,
    ry: 6.47
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m240.04,198.63s-1.09.22,1.64-1.96c2.74-2.18,4.26-1.53,5.89-2.52,1.32-.91,2.87-1.44,4.48-1.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m241.88,201.25c.83-.89,1.89-1.53,3.05-1.85,1.97-.62,3.75-1.75,5.14-3.28,1.5-1.3,3.47-1.93,5.45-1.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m246.36,203.22s2.63-2.18,4.15-3.16c1.16-.74,2.46-1.22,3.83-1.38.94-.3,1.8-.83,2.5-1.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m251.6,196.85c0,.75-1.49,1.38-3.33,1.38s-3.33-.59-3.33-1.38,1.49-1.38,3.33-1.38,3.33.64,3.33,1.38Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 255.8,
    cy: 209.03,
    rx: 9.49,
    ry: 6.47
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m247.56,209.98s-1.09.22,1.63-1.96c2.72-2.18,4.26-1.53,5.9-2.52,1.32-.91,2.87-1.44,4.48-1.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m249.41,212.61c.83-.89,1.88-1.54,3.05-1.87,1.97-.61,3.74-1.74,5.13-3.26,1.52-1.33,3.52-1.96,5.53-1.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m253.86,214.57s2.61-2.18,4.15-3.16c1.15-.73,2.46-1.21,3.81-1.38.95-.3,1.81-.82,2.52-1.52"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-13",
    cx: 255.8,
    cy: 208.2,
    rx: 3.33,
    ry: 1.35
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 221.58,
    cy: 186.32,
    rx: 9.49,
    ry: 6.47
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m213.34,187.29s-1.09.21,1.64-1.96c2.74-2.17,4.26-1.53,5.89-2.52,1.32-.92,2.87-1.45,4.48-1.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m215.16,189.84c.83-.89,1.89-1.53,3.07-1.85,1.97-.62,3.74-1.75,5.13-3.28,1.5-1.31,3.47-1.94,5.45-1.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m219.67,191.86s2.63-2.18,4.15-3.16c1.16-.74,2.46-1.22,3.83-1.38.94-.3,1.8-.83,2.5-1.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m224.91,185.49c0,.75-1.49,1.38-3.33,1.38s-3.32-.61-3.32-1.38,1.48-1.38,3.32-1.38,3.33.64,3.33,1.38Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 229.11,
    cy: 197.68,
    rx: 9.49,
    ry: 6.47
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m220.87,198.63s-1.09.22,1.63-1.96,4.26-1.53,5.9-2.52c1.32-.91,2.87-1.44,4.48-1.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m222.72,201.25c.83-.89,1.89-1.53,3.05-1.85,1.97-.62,3.75-1.75,5.14-3.28,1.5-1.3,3.47-1.93,5.45-1.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m227.2,203.22s2.63-2.18,4.15-3.16c1.15-.74,2.46-1.21,3.81-1.38.95-.3,1.81-.83,2.52-1.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m232.44,196.85c0,.75-1.49,1.38-3.33,1.38s-3.33-.59-3.33-1.38,1.49-1.38,3.33-1.38,3.33.64,3.33,1.38Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 236.63,
    cy: 209.03,
    rx: 9.49,
    ry: 6.47
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m228.4,209.98s-1.09.22,1.63-1.96c2.72-2.18,4.26-1.53,5.9-2.52,1.32-.91,2.87-1.44,4.48-1.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m230.26,212.61c.83-.89,1.88-1.54,3.05-1.87,1.97-.61,3.74-1.74,5.13-3.26,1.5-1.31,3.48-1.94,5.46-1.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m234.73,214.57s2.61-2.18,4.15-3.16c1.15-.74,2.46-1.21,3.81-1.38.95-.3,1.81-.82,2.52-1.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m240.04,208.2c0,.75-1.49,1.38-3.33,1.38s-3.33-.61-3.33-1.38,1.49-1.38,3.33-1.38,3.33.64,3.33,1.38Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-16",
    cx: 202.42,
    cy: 186.32,
    rx: 9.49,
    ry: 6.47
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m194.18,187.29s-1.09.21,1.64-1.96c2.74-2.17,4.26-1.53,5.89-2.52,1.32-.92,2.87-1.45,4.48-1.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m196.04,189.84c.83-.89,1.89-1.53,3.05-1.85,1.97-.62,3.75-1.75,5.14-3.28,1.5-1.31,3.47-1.94,5.45-1.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m200.51,191.86s2.63-2.18,4.15-3.16c1.16-.74,2.46-1.22,3.83-1.38.96-.32,1.83-.88,2.53-1.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m205.75,185.49c0,.75-1.49,1.38-3.33,1.38s-3.33-.61-3.33-1.38,1.49-1.38,3.33-1.38,3.33.64,3.33,1.38Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-16",
    cx: 209.95,
    cy: 197.68,
    rx: 9.49,
    ry: 6.47
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m201.72,198.63s-1.09.22,1.63-1.96,4.26-1.53,5.9-2.52c1.34-.93,2.91-1.47,4.53-1.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m203.57,201.25c.83-.89,1.89-1.53,3.05-1.85,1.97-.62,3.74-1.75,5.13-3.28,1.51-1.3,3.48-1.93,5.46-1.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m208.05,203.22s2.61-2.18,4.15-3.16c1.15-.74,2.46-1.21,3.81-1.38.95-.3,1.81-.83,2.52-1.53"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-13",
    cx: 209.95,
    cy: 196.85,
    rx: 3.33,
    ry: 1.35
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-16",
    cx: 217.47,
    cy: 209.03,
    rx: 9.49,
    ry: 6.47
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m209.25,209.98s-1.09.22,1.63-1.96c2.72-2.18,4.26-1.53,5.9-2.52,1.32-.91,2.86-1.44,4.46-1.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m211.1,212.61c.83-.89,1.88-1.54,3.05-1.87,1.97-.61,3.74-1.74,5.13-3.26,1.52-1.33,3.52-1.96,5.53-1.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m215.58,214.57s2.61-2.18,4.15-3.16c1.15-.74,2.46-1.21,3.81-1.38.95-.3,1.81-.82,2.52-1.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m220.82,208.2c0,.75-1.49,1.38-3.33,1.38s-3.33-.61-3.33-1.38,1.49-1.38,3.33-1.38,3.33.64,3.33,1.38Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 262.06,
    cy: 218.26,
    rx: 9.49,
    ry: 6.47
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m253.86,219.23s-1.09.21,1.63-1.98c2.72-2.18,4.26-1.52,5.9-2.5,1.32-.91,2.86-1.45,4.46-1.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m255.69,221.84c.83-.89,1.89-1.53,3.05-1.85,1.97-.62,3.74-1.75,5.13-3.28,1.5-1.3,3.48-1.93,5.46-1.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m260.16,223.8s2.61-2.18,4.15-3.16c1.15-.75,2.45-1.22,3.81-1.38.95-.3,1.81-.83,2.52-1.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m265.4,217.49c0,.75-1.49,1.38-3.33,1.38s-3.33-.61-3.33-1.38,1.49-1.38,3.33-1.38,3.33.58,3.33,1.38Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 242.9,
    cy: 218.26,
    rx: 9.49,
    ry: 6.47
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m234.68,219.23s-1.09.21,1.63-1.98c2.72-2.18,4.26-1.52,5.9-2.5,1.32-.91,2.86-1.45,4.46-1.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m236.53,221.84c.83-.89,1.88-1.53,3.05-1.85,1.97-.62,3.74-1.75,5.13-3.28,1.52-1.32,3.52-1.95,5.53-1.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m241.01,223.8s2.61-2.18,4.15-3.16c1.15-.75,2.45-1.22,3.81-1.38.95-.3,1.81-.83,2.52-1.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m246.25,217.49c0,.75-1.49,1.38-3.33,1.38s-3.33-.61-3.33-1.38,1.49-1.38,3.33-1.38,3.33.58,3.33,1.38Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-16",
    cx: 223.75,
    cy: 218.26,
    rx: 9.49,
    ry: 6.47
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m215.52,219.23s-1.09.21,1.63-1.98c2.72-2.18,4.26-1.52,5.89-2.5,1.32-.91,2.87-1.44,4.48-1.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m217.38,221.84c.83-.89,1.88-1.53,3.05-1.85,1.97-.62,3.74-1.75,5.13-3.28,1.5-1.3,3.48-1.93,5.46-1.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m221.85,223.8s2.61-2.18,4.15-3.16c1.15-.75,2.45-1.22,3.81-1.38.95-.3,1.81-.83,2.52-1.53"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-13",
    cx: 223.76,
    cy: 217.43,
    rx: 3.33,
    ry: 1.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 216.78,
    y: 222.97,
    width: 60.51,
    height: 6.54
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "180.72 185.6 212.08 229.51 151.57 229.51 120.22 185.6 180.72 185.6"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 120.22,
    y: 179.08,
    width: 60.51,
    height: 6.54
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "212.08 229.51 180.72 185.6 180.72 179.08 212.08 222.97 212.08 229.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "151.57 229.51 120.22 185.6 120.22 179.08 151.57 222.97 151.57 229.51"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 174.59,
    cy: 184.98,
    rx: 9.49,
    ry: 6.47
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m166.35,185.95s-1.08.21,1.64-1.96c2.72-2.17,4.26-1.53,5.89-2.52,1.32-.91,2.87-1.44,4.48-1.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m168.17,188.56c.83-.89,1.88-1.53,3.05-1.85,1.97-.62,3.74-1.75,5.13-3.28,1.52-1.32,3.52-1.95,5.53-1.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m172.68,190.52s2.63-2.18,4.15-3.16c1.15-.75,2.45-1.22,3.81-1.38.95-.3,1.81-.83,2.52-1.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m177.93,184.15c0,.75-1.49,1.38-3.33,1.38s-3.33-.61-3.33-1.38,1.49-1.38,3.33-1.38,3.33.64,3.33,1.38Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 182.12,
    cy: 196.34,
    rx: 9.49,
    ry: 6.47
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m173.88,197.29s-1.09.22,1.64-1.96c2.74-2.18,4.26-1.53,5.89-2.52,1.32-.91,2.87-1.44,4.48-1.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m175.75,199.91c.83-.89,1.88-1.53,3.05-1.85,1.97-.62,3.74-1.75,5.13-3.28,1.51-1.3,3.48-1.93,5.46-1.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m180.21,201.88s2.63-2.18,4.15-3.16c1.16-.74,2.46-1.22,3.83-1.38.95-.3,1.81-.83,2.5-1.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m185.45,195.51c0,.75-1.48,1.38-3.32,1.38s-3.33-.59-3.33-1.38,1.49-1.38,3.33-1.38,3.32.64,3.32,1.38Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 189.65,
    cy: 207.69,
    rx: 9.49,
    ry: 6.47
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m181.41,208.64s-1.09.22,1.64-1.96c2.74-2.18,4.26-1.53,5.89-2.52,1.32-.91,2.87-1.44,4.48-1.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m183.27,211.27c.83-.89,1.89-1.54,3.07-1.87,1.97-.62,3.74-1.74,5.13-3.26,1.52-1.33,3.52-1.96,5.53-1.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m187.74,213.23s2.63-2.18,4.15-3.16c1.16-.74,2.47-1.21,3.83-1.38.94-.3,1.8-.82,2.5-1.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m193.05,206.86c0,.75-1.49,1.38-3.33,1.38s-3.32-.61-3.32-1.38,1.48-1.38,3.32-1.38,3.33.64,3.33,1.38Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 155.43,
    cy: 184.98,
    rx: 9.49,
    ry: 6.47
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m147.19,185.95s-1.09.21,1.64-1.96c2.74-2.17,4.26-1.53,5.89-2.52,1.32-.91,2.87-1.44,4.48-1.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m149.06,188.56c.83-.89,1.88-1.53,3.05-1.85,1.97-.62,3.74-1.75,5.13-3.28,1.49-1.29,3.44-1.92,5.4-1.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m153.52,190.52s2.63-2.18,4.15-3.16c1.16-.74,2.46-1.22,3.83-1.38.95-.3,1.81-.83,2.5-1.53"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-13",
    cx: 155.44,
    cy: 184.15,
    rx: 3.33,
    ry: 1.35
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 162.96,
    cy: 196.34,
    rx: 9.49,
    ry: 6.47
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m154.73,197.29s-1.09.22,1.64-1.96c2.74-2.18,4.26-1.53,5.89-2.52,1.32-.91,2.87-1.44,4.48-1.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m156.58,199.91c.83-.89,1.89-1.53,3.07-1.85,1.97-.62,3.74-1.75,5.13-3.28,1.52-1.32,3.52-1.95,5.53-1.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m161.06,201.88s2.63-2.18,4.15-3.16c1.16-.74,2.46-1.22,3.83-1.38.95-.3,1.81-.83,2.5-1.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m166.29,195.51c0,.75-1.49,1.38-3.33,1.38s-3.32-.59-3.32-1.38,1.48-1.38,3.32-1.38,3.33.64,3.33,1.38Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 170.5,
    cy: 207.69,
    rx: 9.49,
    ry: 6.47
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m162.26,208.64s-1.09.22,1.64-1.96,4.26-1.53,5.89-2.52c1.32-.91,2.87-1.44,4.48-1.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m164.11,211.27c.83-.89,1.88-1.54,3.05-1.87,1.97-.61,3.75-1.74,5.14-3.26,1.5-1.31,3.47-1.94,5.45-1.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m168.59,213.23s2.63-2.18,4.15-3.16c1.16-.74,2.47-1.21,3.83-1.38.94-.3,1.8-.82,2.5-1.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m173.83,206.86c0,.75-1.49,1.38-3.33,1.38s-3.33-.61-3.33-1.38,1.49-1.38,3.33-1.38,3.33.64,3.33,1.38Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-16",
    cx: 136.28,
    cy: 184.98,
    rx: 9.49,
    ry: 6.47
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m128.09,185.95s-1.09.21,1.64-1.96,4.26-1.53,5.89-2.52c1.32-.91,2.87-1.44,4.48-1.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m129.9,188.56c.83-.89,1.88-1.53,3.05-1.85,1.97-.62,3.74-1.75,5.13-3.28,1.52-1.32,3.52-1.96,5.53-1.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m134.37,190.52s2.63-2.18,4.15-3.16c1.16-.74,2.46-1.22,3.83-1.38.95-.3,1.81-.83,2.5-1.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m139.61,184.15c0,.75-1.48,1.38-3.32,1.38s-3.33-.61-3.33-1.38,1.48-1.38,3.33-1.38,3.32.64,3.32,1.38Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-16",
    cx: 143.81,
    cy: 196.34,
    rx: 9.49,
    ry: 6.47
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m135.57,197.29s-1.09.22,1.64-1.96c2.74-2.18,4.26-1.53,5.89-2.52,1.32-.91,2.87-1.44,4.48-1.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m137.42,199.91c.83-.89,1.89-1.53,3.07-1.85,1.97-.62,3.74-1.75,5.13-3.28,1.5-1.3,3.47-1.93,5.45-1.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m141.91,201.88s2.63-2.18,4.15-3.16c1.16-.74,2.46-1.22,3.83-1.38.94-.3,1.8-.83,2.5-1.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m147.14,195.51c0,.75-1.49,1.38-3.33,1.38s-3.32-.59-3.32-1.38,1.48-1.38,3.32-1.38,3.33.64,3.33,1.38Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-16",
    cx: 151.34,
    cy: 207.69,
    rx: 9.49,
    ry: 6.47
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m143.1,208.64s-1.09.22,1.63-1.96c2.72-2.18,4.26-1.53,5.9-2.52,1.32-.91,2.87-1.44,4.48-1.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m144.95,211.27c.83-.89,1.88-1.54,3.05-1.87,1.97-.61,3.75-1.74,5.14-3.26,1.5-1.31,3.47-1.94,5.45-1.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m149.43,213.23s2.63-2.18,4.15-3.16c1.15-.73,2.46-1.21,3.81-1.38.95-.3,1.81-.82,2.52-1.52"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-13",
    cx: 151.34,
    cy: 206.86,
    rx: 3.33,
    ry: 1.35
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m205.49,216.92c0,3.58-4.26,6.47-9.49,6.47s-9.51-2.89-9.51-6.47,4.26-6.47,9.51-6.47,9.49,2.89,9.49,6.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m187.69,217.89s-1.09.21,1.63-1.98c2.72-2.18,4.26-1.52,5.9-2.5,1.32-.92,2.87-1.45,4.48-1.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m189.54,220.5c.83-.89,1.89-1.53,3.05-1.85,1.97-.62,3.75-1.75,5.14-3.28,1.5-1.31,3.47-1.94,5.45-1.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m194.02,222.46s2.63-2.18,4.15-3.16c1.15-.74,2.46-1.21,3.81-1.38.95-.3,1.81-.83,2.52-1.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m199.26,216.1c0,.75-1.49,1.38-3.33,1.38s-3.33-.61-3.33-1.38,1.49-1.38,3.33-1.38,3.33.62,3.33,1.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m186.26,216.92c0,3.58-4.26,6.47-9.49,6.47s-9.51-2.89-9.51-6.47,4.26-6.47,9.51-6.47,9.49,2.89,9.49,6.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m168.53,217.89s-1.09.21,1.63-1.98c2.72-2.18,4.26-1.52,5.9-2.5,1.32-.92,2.87-1.45,4.48-1.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m170.38,220.5c.83-.89,1.89-1.53,3.05-1.85,1.97-.62,3.74-1.75,5.13-3.28,1.5-1.3,3.48-1.93,5.46-1.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m174.86,222.46s2.61-2.18,4.15-3.16c1.15-.74,2.46-1.21,3.81-1.38.95-.3,1.81-.83,2.52-1.53"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-13",
    cx: 176.77,
    cy: 216.09,
    rx: 3.33,
    ry: 1.35
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m167.11,216.92c0,3.58-4.26,6.47-9.51,6.47s-9.49-2.89-9.49-6.47,4.26-6.47,9.49-6.47,9.51,2.89,9.51,6.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m149.38,217.89s-1.09.21,1.63-1.98c2.72-2.18,4.26-1.52,5.9-2.5,1.32-.91,2.86-1.44,4.46-1.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m151.23,220.5c.83-.89,1.89-1.53,3.05-1.85,1.97-.62,3.74-1.75,5.13-3.28,1.52-1.32,3.52-1.95,5.53-1.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m155.73,222.46s2.61-2.18,4.15-3.16c1.15-.75,2.45-1.22,3.81-1.38.95-.3,1.81-.83,2.52-1.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m160.95,216.1c0,.75-1.49,1.38-3.33,1.38s-3.33-.61-3.33-1.38,1.49-1.38,3.33-1.38,3.33.62,3.33,1.38Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 151.57,
    y: 222.97,
    width: 60.51,
    height: 6.54
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "115.5 185.6 146.86 229.51 86.35 229.51 55 185.6 115.5 185.6"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 55,
    y: 179.08,
    width: 60.51,
    height: 6.54
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "146.86 229.51 115.5 185.6 115.5 179.08 146.86 222.97 146.86 229.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "86.35 229.51 55 185.6 55 179.08 86.35 222.97 86.35 229.51"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 86.35,
    y: 222.97,
    width: 60.51,
    height: 6.54
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m110.13,180.58s-4.59-2.97-17.28-4.05c-12.69-1.08-28.06,6.21-28.33,9.44-.28,3.23-.8,6.21,12.95,8.36,13.75,2.16,36.97-.26,38.59-3.5,1.62-3.23.77-8.38-5.93-10.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m74.69,181.39s4.88,1.38,6.63,9.16c0,0,.97-6.23-.98-8.97-1.95-2.74-5.65-.19-5.65-.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m82.48,178.95c3.93,2.09,6.69,5.86,7.48,10.24,0,0,.97-6.25-.98-8.97s-6.5-1.27-6.5-1.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m90.94,178.53s5.45,2.67,7.2,10.46c0,0,.97-6.23-.98-8.97-1.95-2.74-6.22-1.49-6.22-1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m99.46,178.95c4.01,2.54,6.86,6.57,7.91,11.21,0,0,.97-6.23-.98-8.97-1.95-2.74-6.92-2.24-6.92-2.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m119.46,194.21s-4.59-2.97-17.28-4.05-28.06,6.21-28.33,9.44-.8,6.21,12.95,8.38c13.75,2.17,36.97-.28,38.59-3.51,1.62-3.23.82-8.38-5.93-10.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m84.06,195.01s4.88,1.38,6.63,9.16c0,0,.97-6.23-.98-8.97s-5.65-.19-5.65-.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m91.79,192.61c3.93,2.09,6.69,5.86,7.48,10.24,0,0,.98-6.25-.97-8.97s-6.51-1.27-6.51-1.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m100.31,192.15s5.45,2.67,7.2,10.46c0,0,.97-6.23-.98-8.97-1.95-2.74-6.22-1.49-6.22-1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m108.83,192.61c3.99,2.55,6.81,6.58,7.85,11.21,0,0,.97-6.23-.98-8.97s-6.87-2.24-6.87-2.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m128.83,207.81s-4.59-2.97-17.28-4.05c-12.69-1.08-28.06,6.21-28.33,9.44-.28,3.23-.73,6.23,12.95,8.43,13.68,2.2,36.97-.28,38.59-3.51s.82-8.39-5.93-10.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m93.43,208.64s4.88,1.38,6.63,9.16c0,0,.97-6.23-.98-8.97s-5.65-.19-5.65-.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m101.16,206.21c3.93,2.09,6.69,5.86,7.48,10.24,0,0,.98-6.25-.97-8.97s-6.51-1.27-6.51-1.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m109.68,205.78s5.45,2.67,7.2,10.48c0,0,.97-6.25-.98-8.97-1.95-2.72-6.22-1.51-6.22-1.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m118.2,206.21c3.99,2.55,6.81,6.58,7.85,11.21,0,0,.97-6.23-.98-8.97-1.95-2.74-6.87-2.24-6.87-2.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m245,252.63s-4.59-2.96-17.26-4.04c-12.67-1.08-28.07,6.21-28.33,9.44-.26,3.23-.82,6.21,12.95,8.29,13.77,2.09,36.97-.26,38.59-3.51s.8-8.29-5.94-10.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m209.64,253.42s4.86,1.38,6.62,9.16c0,0,.98-6.23-.97-8.97-1.95-2.74-5.65-.19-5.65-.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m217.35,251.01c3.93,2.08,6.68,5.85,7.48,10.23,0,0,.98-6.23-.97-8.97-1.95-2.74-6.51-1.26-6.51-1.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m225.86,250.66s5.45,2.67,7.2,10.46c0,0,.98-6.23-.97-8.97-1.95-2.74-6.23-1.49-6.23-1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m234.39,251.01c3.99,2.55,6.81,6.58,7.84,11.21,0,0,.98-6.25-.97-8.97-1.95-2.72-6.87-2.24-6.87-2.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m254.37,266.27s-4.59-2.97-17.26-4.05c-12.67-1.08-28.07,6.21-28.33,9.44s-.82,6.21,12.95,8.36c13.77,2.16,36.97-.26,38.59-3.51,1.62-3.25.8-8.36-5.94-10.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m218.99,267.07s4.86,1.38,6.62,9.16c0,0,.98-6.23-.97-8.97-1.95-2.74-5.65-.19-5.65-.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m226.72,264.64c3.93,2.08,6.68,5.85,7.48,10.23,0,0,.98-6.23-.98-8.97-1.96-2.74-6.5-1.26-6.5-1.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m235.23,264.21s5.45,2.67,7.2,10.46c0,0,.98-6.23-.97-8.97s-6.23-1.49-6.23-1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m243.76,264.64c3.99,2.56,6.8,6.59,7.84,11.21,0,0,.98-6.25-.97-8.97-1.95-2.72-6.87-2.24-6.87-2.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m263.74,279.9s-4.59-2.97-17.26-4.05c-12.67-1.08-28.07,6.21-28.33,9.44-.26,3.23-.82,6.21,12.95,8.36,13.77,2.16,36.97-.26,38.59-3.51,1.62-3.25.76-8.36-5.94-10.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m228.35,280.7s4.88,1.38,6.63,9.16c0,0,.98-6.23-.97-8.97-1.95-2.74-5.67-.19-5.67-.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m236.09,278.3c3.93,2.08,6.68,5.85,7.48,10.23,0,0,.97-6.23-.98-8.97-1.95-2.74-6.5-1.26-6.5-1.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m244.6,277.84s5.45,2.67,7.2,10.46c0,0,.98-6.23-.97-8.97-1.95-2.74-6.23-1.49-6.23-1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m253.12,278.3c3.99,2.55,6.81,6.58,7.85,11.21,0,0,.98-6.25-.97-8.97-1.95-2.72-6.88-2.24-6.88-2.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m311.26,252.63s-4.59-2.96-17.26-4.04c-12.67-1.08-28.07,6.21-28.33,9.44-.26,3.23-.82,6.21,12.95,8.29,13.77,2.09,36.97-.26,38.59-3.51,1.62-3.25.8-8.29-5.94-10.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m275.86,253.42s4.88,1.38,6.63,9.16c0,0,.98-6.23-.97-8.97-1.95-2.74-5.67-.19-5.67-.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m283.6,251.01c3.93,2.08,6.68,5.85,7.48,10.23,0,0,.97-6.23-.98-8.97-1.95-2.74-6.5-1.26-6.5-1.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m292.12,250.66s5.45,2.67,7.2,10.46c0,0,.98-6.23-.97-8.97s-6.23-1.49-6.23-1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m300.63,251.01c3.99,2.55,6.81,6.58,7.85,11.21,0,0,.98-6.25-.97-8.97-1.95-2.72-6.88-2.24-6.88-2.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m320.63,266.27s-4.59-2.97-17.26-4.05c-12.67-1.08-28.07,6.21-28.33,9.44s-.82,6.21,12.95,8.36c13.77,2.16,36.96-.26,38.59-3.51,1.63-3.25.8-8.36-5.94-10.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m285.24,267.07s4.88,1.38,6.63,9.16c0,0,.98-6.23-.97-8.97s-5.67-.19-5.67-.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m292.97,264.64c3.93,2.08,6.68,5.85,7.48,10.23,0,0,.97-6.23-.98-8.97-1.95-2.74-6.5-1.26-6.5-1.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m301.49,264.21s5.45,2.67,7.2,10.46c0,0,.98-6.23-.97-8.97-1.95-2.74-6.23-1.49-6.23-1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m310,264.64c3.99,2.55,6.81,6.58,7.85,11.21,0,0,.98-6.25-.97-8.97-1.95-2.72-6.88-2.24-6.88-2.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m330,279.9s-4.59-2.97-17.26-4.05c-12.67-1.08-28.07,6.21-28.33,9.44-.26,3.23-.82,6.21,12.95,8.36,13.77,2.16,36.96-.26,38.59-3.51,1.63-3.25.84-8.36-5.94-10.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m294.61,280.7s4.88,1.38,6.63,9.16c0,0,.97-6.23-.98-8.97-1.95-2.74-5.65-.19-5.65-.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m302.35,278.3c3.93,2.08,6.68,5.85,7.48,10.23,0,0,.97-6.23-.98-8.97s-6.5-1.26-6.5-1.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m310.86,277.84s5.45,2.67,7.2,10.46c0,0,.98-6.23-.98-8.97-1.96-2.74-6.22-1.49-6.22-1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m319.37,278.3c3.99,2.55,6.81,6.58,7.85,11.21,0,0,.98-6.25-.97-8.97-1.95-2.72-6.88-2.24-6.88-2.24Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-273"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m168.6,255s-31.51,6.51-35.66,11.86c-1.96,2.53,1.93,17.23,1.93,17.23l12.13,60.55h82.25s1.62-50.72,1.01-56.84c-.61-6.12-5.53-17.29-7.77-20.73-2.24-3.44-26.26-10.13-26.26-10.13l-27.64-1.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m144.17,483.69l-1.67,82.8s-2.25,3.68-5.24,8.15c-2.99,4.48-5.78,7.15-5.02,9.67s6.91,3.29,10.41,1.01,8.87-13.89,9.67-16.68,1.77-9.4,1.77-9.4l10.93-72.53-20.86-3.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m199.74,578.9l-5.94-90.75,19.35-.57-3.83,82.92s7.12,5.29,9.67,6.91,11.35,5.2,11.35,6.7-4.69,2.25-10.13,1.31-16.41,1.22-18.66-.28-1.59-2.7-1.81-6.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m132.24,584.33c.76,2.53,8.69,3.29,12.25,1.01,2.4-1.55,4.26-6.51,5.65-11.37l-.3.18c-3.7,2.71-8.68,2.91-12.58.5-2.92,4.35-5.78,7.15-5.02,9.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m230.37,584.25c0-1.51-8.72-5.02-11.35-6.7l-.88-.58c-1.25,1.04-2.75,1.74-4.35,2.03-4.73-.07-9.45-.41-14.14-1v.9c.19,3.57-.37,4.88,1.88,6.39,2.25,1.51,13.21-.66,18.66.28,5.45.94,10.19.18,10.19-1.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m223.66,391.74s-.83-19.68-2.09-31.79c-1.03-8.51-2.71-16.92-5.03-25.17l-65.75-.41-3.79,10.27s-5.42,15.2-5.85,30.31c-.43,15.11,2.46,112.54,2.46,112.54,0,0,27.41,4.41,40.33,4.15,10.02-.44,20-1.39,29.92-2.83,0,0,2.53-21.74,3.15-35.28.54-11.37,6.4-38.55,5.83-58.14l.8-3.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m137.56,264.1s-6.91,2.39-8.94,8.06c-2.03,5.67-2.39,12.52-1.49,22.36s4.77,41.14,4.77,41.14c0,0-.59,5.07,6.56,4.77,7.16-.3,12.83-6.55,13.42-9.84.59-3.29,2.42-20.08,2.38-25.64s-.88-23.5-5.06-30.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m152.86,325.41l-.75-4.86s1.12-20.98.37-29.22"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 195.1,
    y: 282.24,
    width: 12.78,
    height: 5.02
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m132.75,340.01s-1.66-4.57-1.45-6.65c.21-2.07.83-6.66,4.99-8.94,2.13-1.31,4.57-2.03,7.08-2.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m137.96,320.88s4.99-2.28,8.94,1.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "171.93 244.24 168.6 255 182.35 269.55 196.26 256.93 193.84 248.22 171.93 244.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m172.87,245.53s7.49,10.9,10.42,11.36c2.93.46,10.55-8.67,10.55-8.67l-20.97-2.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m167.21,223.39s-3.94-1.99-6.29-.7c-2.35,1.29-4.92,5.86-4.45,10.31s7.38,7.27,9.14,6.91c1.76-.36,3.51-3.16,3.51-3.16l-.82-12.77-1.09-.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m167.16,219.66s-1.96-4.73-4.31-1.93c-2.35,2.79,1,7.79,2.9,9.08l1.92,1.29-.51-8.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m203.78,228.89s2.85-4.26,4.62-1.06-2.49,7.46-4.62,8.29l-2.13.88,2.13-8.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m167.21,223.39s-.17,14.39,1.06,17.4c1.23,3.01,12.08,11.36,14.57,11.89s12.07-3.37,14.37-5.14c2.31-1.77,6.74-17.4,6.74-17.4l1.77-12.95s-.53-4.44-7.45-8.87c-6.92-4.44-20.05-10.66-22.18-9.95-2.13.7-5.33,9.41-6.04,11.54-1.27,4.42-2.22,8.93-2.85,13.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m176.09,195.37s-7.1,1.38-7.64,5.53c-.54,4.15-1.24,22.54-1.24,22.54,0,0,1.78-5.53,2.14-6.03.36-.5,2.13-3.91,4.15-7.46,1.28-2.59,2.21-5.33,2.76-8.17,1.12,3.15,3.02,5.96,5.53,8.17,3.9,3.19,17.04,7.28,19.35,7.81,1.72.4,2.91,1.97,2.85,3.73.18,1.38-.18,7.45-.18,7.45l3.73-12.44s5.14-4.08,2.13-9.94c-3.01-5.86-9.23-9.23-18.99-12.07-9.76-2.83-10.86-4.84-14.58.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m173.78,219.31c3.01-.79,6.2-.34,8.87,1.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m192.24,222.14s3.46-1.87,7.81,1.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m183.18,233.68c.97,1.13,2.43,1.73,3.91,1.6l2.31-.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m178.22,239.18s4.62,2.67,8.15,2.67c2.13,0,4.25-.42,6.22-1.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m181.11,224.11c-1.69-.83-3.61-1.04-5.43-.61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m192.41,226.01c1.59-.38,3.27-.05,4.6.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m179.41,224.4c-.11.65-.72,1.09-1.37.98s-1.09-.72-.98-1.37c.09-.57.59-.99,1.17-1,.7.05,1.23.66,1.18,1.36,0,0,0,.01,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m195.73,227.08c-.11.65-.72,1.09-1.37.98s-1.09-.72-.98-1.37c.09-.57.59-.99,1.17-1,.71.06,1.23.68,1.17,1.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m214.15,290.74c.98,3.55,1.96,7.88,1.73,10.43-.44,4.92-1.38,10.28-1.38,10.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m212.32,284.88s.39,1.09.9,2.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m159.8,293.26c.49,1.16.91,2.36,1.27,3.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m153.29,280.87s2.85,4.56,5.2,9.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m145.31,279.47s3.19,1.8,5.18,7.38"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 188.09,
    y: 302.62,
    width: 71.27,
    height: 41.97
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m259.39,314.98h0l-20.4,14.28-27.64-14.5-23.19,7.67v22.21h71.23v-29.66Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 211.61,
    y: 302.62,
    width: 47.74,
    height: 41.97
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m259.39,314.98h0l-20.4,14.28-27.38-14.33v29.71h47.78v-29.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m180.21,331.26s3.77-5.74,4.75-6.65c2.02-1.27,4.14-2.38,6.34-3.32,1.17-.58,3.87-4.37,4.95-3.57s.97,1.84.21,3.43c-.94,1.57-2.14,2.97-3.54,4.15-.45.42-.83.91-1.12,1.45,0,0,14.95-.39,15.69.25.57.61.54,1.58-.07,2.15-.14.13-.29.23-.47.3-1.01.4-11.93,2.1-11.93,2.1l.59,1.38s12.98,1.11,13.71,1.76.46,1.87-.7,2.45-11.86.37-12.44.58.18,1.08.95,1.26,9.67.83,9.96,1.7c.29.87-.46,1.56-1.38,1.71s-8.89-.44-9.22-.43,6.03,1.93,6.03,1.93c-.57.42-1.22.72-1.91.88-1.19.29-9.19-1.52-9.19-1.52-2.05-.18-4.09-.54-6.08-1.06-2.35-.73-5.83-2.27-5.83-2.27,0,0-37.88,3.81-41.46,3.37-3.58-.44-5.53-2.07-5.53-5.69s4.38-11.06,9.59-11.75c5.21-.69,19.24,1.24,24.88,2.89,4.34,1.14,8.76,1.98,13.21,2.52Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Counter--inject-273"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m104.21,388.3s2.32-9.67,4.35-10.45,5.09,5.67,6.11,10.45h-10.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m86.63,388.12h54.15c2.58,0,4.67,2.09,4.67,4.67h0v22.11h-63.42v-22.11c0-2.55,2.05-4.63,4.6-4.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m117.71,387.72s2.76-9.67,5.53-9c2.76.68,4.51,9.29,4.51,9.29l-10.03-.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m97.83,387.72s2.03-7.55,4.22-7.7c2.18-.15,3.77,8.14,3.77,8.14l-7.99-.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m145.52,392.79c0-2.58-2.09-4.67-4.67-4.67h-54.15c-2.58,0-4.67,2.09-4.67,4.67h0v10.31l.7,1.17s2.61,4.06,3.77.29c1.16-3.77,3.48-11.32,4.35-8.71.87,2.61-1.16,6.09,2.9,5.8,4.06-.29,5.53-7.55,7.26-7.55s.58,10.45,5.53,9c4.95-1.45,4.06-9.29,6.39-9.29s5.24,4.64,7.27,2.32c2.03-2.32,1.74-3.5,3.19-4.08,1.45-.58,3.48,3.5,4.64,6.69s5.53,1.38,7.26-1.16c1.73-2.54,2.61-3.19,3.48,2.9.87,6.09,3.19,6.91,5.22,4.64.62-.77,1.14-1.62,1.53-2.53v-9.83Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 77.41,
    y: 413.38,
    width: 72.86,
    height: 3.23
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m362.15,388.3s2.32-9.67,4.35-10.45,5.09,5.67,6.09,10.45h-10.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m344.64,388.12h54.15c2.58,0,4.67,2.09,4.67,4.67h0v22.11h-63.51v-22.11c0-2.58,2.09-4.67,4.67-4.67h.01Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "352.49 388.12 339.97 397.71 339.97 406.4 363.86 388.12 352.49 388.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m385.89,388.12h-11.37l-31,23.73c-.98.71-1.51,1.89-1.38,3.1h8.64l35.12-26.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m403.31,391.63c-.52-2.07-2.38-3.53-4.52-3.54h-2.23l-31.01,23.73c-.95.73-1.45,1.9-1.31,3.1h8.64l30.43-23.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m403.46,408.41v-8.71l-15.87,12.15c-.98.71-1.51,1.89-1.38,3.1h8.64l8.61-6.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m375.65,387.72s2.76-9.67,5.53-9c2.76.68,4.51,9.29,4.51,9.29l-10.03-.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m355.76,387.72s2.03-7.55,4.15-7.7c2.11-.15,3.77,8.14,3.77,8.14l-7.92-.44Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 335.34,
    y: 413.38,
    width: 72.86,
    height: 3.23
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m174.27,388.12h54.15c2.58,0,4.67,2.09,4.67,4.67h0v22.11h-63.53v-22.11c0-2.58,2.09-4.67,4.67-4.67.01,0,.03,0,.04,0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 170,
    y: 400.82,
    width: 63.16,
    height: 5.39
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 177.05,
    cy: 392.61,
    r: 1.91
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 189.68,
    cy: 392.61,
    r: 1.91
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 202.31,
    cy: 392.61,
    r: 1.91
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 214.94,
    cy: 392.61,
    r: 1.91
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 227.57,
    cy: 392.61,
    r: 1.91
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 177.05,
    cy: 409.83,
    r: 1.91
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 189.68,
    cy: 409.83,
    r: 1.91
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 202.31,
    cy: 409.83,
    r: 1.91
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 214.94,
    cy: 409.83,
    r: 1.91
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 227.57,
    cy: 409.83,
    r: 1.91
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 164.98,
    y: 413.38,
    width: 72.86,
    height: 3.23
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 268.42,
    y: 359.05,
    width: 30.96,
    height: 18.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 258.45,
    y: 377.5,
    width: 50.87,
    height: 18.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 252.15,
    y: 396.28,
    width: 63.49,
    height: 18.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 247.53,
    y: 413.38,
    width: 72.86,
    height: 3.23
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 268.42,
    y: 359.05,
    width: 30.96,
    height: 6.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 258.45,
    y: 377.5,
    width: 50.87,
    height: 5.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 252.15,
    y: 396.28,
    width: 63.49,
    height: 5.53
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 221.27,
    cy: 457.18,
    r: 3.48
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 169.2,
    cy: 457.18,
    r: 3.48
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 162.44,
    cy: 474.39,
    r: 3.48
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 226.8,
    cy: 474.39,
    r: 3.48
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 169.67,
    y: 444.78,
    width: 50.87,
    height: 18.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 163.35,
    y: 463.56,
    width: 63.49,
    height: 18.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 158.73,
    y: 480.67,
    width: 72.86,
    height: 3.23
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 169.67,
    y: 444.78,
    width: 50.87,
    height: 5.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 163.35,
    y: 463.56,
    width: 63.49,
    height: 5.53
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 176.99,
    cy: 457.18,
    r: 3.48
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 188.23,
    cy: 457.18,
    r: 3.48
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m202.96,457.18c0,1.93-1.57,3.5-3.5,3.5-1.93,0-3.5-1.57-3.5-3.5s1.57-3.5,3.5-3.5c0,0,0,0,.01,0,1.92,0,3.48,1.56,3.48,3.48,0,0,0,0,0,.01Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 210.71,
    cy: 457.18,
    r: 3.48
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 176.99,
    cy: 474.39,
    r: 3.48
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 167.76,
    cy: 474.39,
    r: 3.48
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 188.23,
    cy: 474.39,
    r: 3.48
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m202.96,474.4c0,1.93-1.57,3.5-3.5,3.5-1.93,0-3.5-1.57-3.5-3.5s1.57-3.5,3.5-3.5c0,0,0,0,.01,0,1.92,0,3.48,1.56,3.48,3.48,0,0,0,0,0,.01Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 210.71,
    cy: 474.39,
    r: 3.48
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 220.65,
    cy: 474.39,
    r: 3.48
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m369.38,455.59s2.32-9.67,4.37-10.46,5.07,5.67,6.09,10.46h-10.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m351.86,455.4h54.15c2.58,0,4.67,2.09,4.67,4.67h0v22.11h-63.49v-22.11c0-2.58,2.09-4.67,4.67-4.67h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m382.88,455.01s2.76-9.67,5.53-9.01,4.49,9.3,4.49,9.3l-10.02-.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m363.05,455.01s2.03-7.56,4.22-7.7c2.18-.14,3.77,8.13,3.77,8.13l-7.99-.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m410.69,460.08c0-2.58-2.08-4.68-4.66-4.69h-54.16c-2.58,0-4.67,2.09-4.67,4.67h0v10.34l.7,1.17s2.61,4.08,3.77.29c1.16-3.79,3.48-11.32,4.35-8.71s-1.16,6.09,2.9,5.8c4.06-.29,5.53-7.55,7.26-7.55s.58,10.45,5.53,9c4.95-1.45,4.08-9.29,6.4-9.29s5.22,4.64,7.26,2.32c2.03-2.32,1.74-3.48,3.19-4.06,1.45-.58,3.48,3.48,4.64,6.68,1.16,3.19,5.53,1.45,7.26-1.16,1.73-2.61,2.61-3.19,3.48,2.9.87,6.09,3.21,6.91,5.24,4.64.62-.77,1.13-1.61,1.52-2.52v-9.85Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 342.58,
    y: 480.67,
    width: 72.86,
    height: 3.23
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 277.99,
    y: 463.56,
    width: 25.33,
    height: 18.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 277.99,
    y: 470.54,
    width: 25.33,
    height: 5.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 306.84,
    y: 463.56,
    width: 25.33,
    height: 18.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 306.84,
    y: 470.54,
    width: 25.33,
    height: 5.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 249.14,
    y: 463.56,
    width: 25.33,
    height: 18.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 244.52,
    y: 480.67,
    width: 92.7,
    height: 3.23
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 249.14,
    y: 470.54,
    width: 25.33,
    height: 5.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 421.81,
    y: 463.56,
    width: 25.33,
    height: 18.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 421.81,
    y: 470.54,
    width: 25.33,
    height: 5.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 450.67,
    y: 463.56,
    width: 25.33,
    height: 18.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 450.67,
    y: 470.54,
    width: 25.33,
    height: 5.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 392.97,
    y: 463.56,
    width: 25.33,
    height: 18.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 388.34,
    y: 480.67,
    width: 92.7,
    height: 3.23
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 392.97,
    y: 470.54,
    width: 25.33,
    height: 5.53
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m505.77,407.85c-15.94-34.55-30.02-53.64-33.79-58.13h-44.79v231.25h105.34s7.93-97.95-26.76-173.12Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 43.01,
    y: 344.57,
    width: 429.49,
    height: 4.85
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m440.03,421.45H58.22c-1.34,0-2.42-1.08-2.42-2.42h0c0-1.34,1.08-2.42,2.42-2.42h381.81c1.34,0,2.42,1.08,2.42,2.42h0c0,1.34-1.08,2.42-2.42,2.42Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 87.9,
    cy: 455.17,
    rx: 5.82,
    ry: 5.46
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m107.75,455.2c.17,3.22-2.3,5.96-5.52,6.13-3.22.17-5.96-2.3-6.13-5.52-.17-3.22,2.3-5.96,5.52-6.13.1,0,.21,0,.31,0,3.12-.09,5.73,2.36,5.82,5.48,0,.02,0,.03,0,.05Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 115.94,
    cy: 455.17,
    rx: 5.82,
    ry: 5.46
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 129.97,
    cy: 455.17,
    rx: 5.82,
    ry: 5.46
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m81.64,455.4h54.15c2.58,0,4.67,2.09,4.67,4.67h0v22.11h-63.51v-22.11c0-2.58,2.09-4.67,4.67-4.67h.01Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 72.34,
    y: 480.67,
    width: 72.86,
    height: 3.23
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m135.79,455.4h-54.15c-2.59,0-4.69,2.1-4.69,4.69v8.29l.1.17s3.36,1.67,4.75,0c1.4-1.67.29-7.56,3.36-6.44s1.38,7.56,5.53,7.56,4.75-5.6,6.72-5.04,3.07,1.96,4.48,1.38,2.52-2.53,3.91-3.08,2.52,3.08,5.03,5.32c2.52,2.24,5.04,0,7.84-3.08,2.79-3.08,2.76-1.69,5.87.55,3.11,2.24,4.15,1.96,5.32,0,1.17-1.96,4.15-4.46,5.03-1.38.88,3.08,1.67,5.32,3.91,4.75.57-.14,1.1-.37,1.59-.69v-8.29c.02-2.56-2.04-4.66-4.6-4.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m482.87,487.87H58.22c-1.34,0-2.42-1.08-2.42-2.42h0c0-1.34,1.07-2.42,2.4-2.43,0,0,0,0,.01,0h424.66c1.34,0,2.42,1.09,2.42,2.43h0c0,1.34-1.08,2.42-2.42,2.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m121.61,407.85c-15.95-34.55-30.02-53.64-33.79-58.13h-44.81v231.25h105.36s7.93-97.95-26.76-173.12Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 42.87,
    y: 525.94,
    width: 490.5,
    height: 60.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 143.81,
    y: 525.94,
    width: 394.02,
    height: 60.29
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 471.79,
    y1: 388.97,
    x2: 306.57,
    y2: 511.15
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 339.58,
    y1: 458.89,
    x2: 268.93,
    y2: 511.15
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 252.8,
    y1: 366.07,
    x2: 145.98,
    y2: 445.06
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Cake--inject-273"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m358.9,315.39h-45.97c-8.81,0-16.66,5.53-19.63,13.82l-4.51,12.77h94.23l-4.51-12.77c-2.96-8.29-10.82-13.83-19.63-13.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m341.26,307.72c0-2.95-2.38-5.35-5.34-5.36s-5.35,2.38-5.36,5.34c0,2.23,1.37,4.23,3.46,5.02.02,1.11-.63,2.12-1.64,2.57h6.4c-.95-.41-1.58-1.33-1.62-2.36,2.41-.57,4.11-2.72,4.1-5.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m357.02,322.66h-43.85c-2.23,0-4.16,1.54-4.67,3.7l-3.68,15.51h60.55l-3.7-15.51c-.51-2.16-2.43-3.69-4.64-3.7Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "304.82 341.89 365.37 341.89 362.35 329.13 307.83 329.13 304.82 341.89"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 309.01,
    y1: 342.08,
    x2: 316.44,
    y2: 329.32
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 317.4,
    y1: 342.08,
    x2: 324.82,
    y2: 329.32
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 325.77,
    y1: 342.08,
    x2: 333.19,
    y2: 329.32
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 334.15,
    y1: 342.08,
    x2: 341.57,
    y2: 329.32
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 342.52,
    y1: 342.08,
    x2: 349.94,
    y2: 329.32
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 350.9,
    y1: 342.08,
    x2: 358.33,
    y2: 329.32
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 359.27,
    y1: 342.08,
    x2: 363.65,
    y2: 335.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 285.07,
    y: 341.55,
    width: 101.02,
    height: 2.86
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPadaria);
export default __webpack_public_path__ + "static/media/Padaria.766fc3b13ddf22370cbbcd62a61af39c.svg";
export { ForwardRef as ReactComponent };